(function () {
  'use strict';

  /**
   * 4U Virtual Barber — Implementation Guide v1.0
   * Listen first. Recommend second. Explain why. Teach one useful technique.
   */

  const cfg = window.FourUChatConfig || {};
  const FREE = cfg.freeShipping || 30;
  const SHIP = cfg.shippingPrice || '£3.99';
  const EMAIL = cfg.email || 'brad@4uhairproducts.com';
  const SHOP = cfg.shopUrl || '';
  const PRODUCTS_URL = cfg.productsUrl || '/collections/all';
  const BRAND = cfg.brand || {};
  const SOCIAL = cfg.social || {};
  const DISCOUNT = cfg.discountCode || 'WELCOME10';
  const POLICIES = Array.isArray(cfg.policies) ? cfg.policies : [];

  function findPolicy(matchers) {
    const list = [].concat(matchers).map((m) => String(m).toLowerCase());
    for (let i = 0; i < POLICIES.length; i++) {
      const title = String((POLICIES[i] && POLICIES[i].title) || '').toLowerCase();
      const url = POLICIES[i] && POLICIES[i].url;
      if (!url || !title) continue;
      for (let j = 0; j < list.length; j++) {
        if (title.indexOf(list[j]) !== -1) return POLICIES[i];
      }
    }
    return null;
  }

  function policyLink(matchers, fallbackLabel) {
    const p = findPolicy(matchers);
    if (!p) return '';
    const label = fallbackLabel || p.title;
    return `<a href="${escapeHtml(p.url)}" target="_blank" rel="noopener">${escapeHtml(label)}</a>`;
  }

  function allPolicyLinksHtml() {
    if (!POLICIES.length) {
      return `<p>Full legal pages are linked in the website footer. For anything unclear, email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`;
    }
    const items = POLICIES.map((p) => `• <a href="${escapeHtml(p.url)}" target="_blank" rel="noopener">${escapeHtml(p.title)}</a>`).join('<br>');
    return `<p>${items}</p>`;
  }

  /* ========== Structured product KB (live storefront + barber consult) ========== */
  const PRODUCT_KB = {
    'grooming-clay': {
      name: '4U Grooming Clay',
      handle: 'grooming-clay',
      sku: '4U-GC-100',
      size: '100ml',
      priceFallback: '£18',
      badge: '',
      hold: 'Strong / Firm',
      holdLevel: 'strong',
      finish: 'Matte / low shine',
      finishPlain: 'matte with little to no shine',
      galleryHold: 'Firm',
      galleryFinish: 'Low Shine',
      waterSoluble: true,
      lengths: ['very-short', 'short', 'medium'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['textured-crop', 'messy', 'quiff', 'short-matte', 'skin-fade', 'structured', 'professional', 'side-part-matte'],
      summary: 'Strong-hold grooming clay with a matte / low-shine finish — built for structured, textured styles on short to medium hair. Great across hair types when you want control without gloss.',
      storefrontCopy: 'Has a matte finish with a strong hold, perfect for all hair types.',
      recommendWhen: ['strong hold', 'matte or low shine', 'structured crop', 'quiff', 'professional short style'],
      avoidWhen: ['high shine polished look', 'loose flowing long movement', 'curl definition cream routine'],
      application: [
        'Start with dry or almost-dry hair.',
        'Warm a small amount between the palms.',
        'Work from the back towards the front, then use fingertips for separation and texture.'
      ],
      tip: 'Start small — you can always add more. Pinch sections with your fingertips for texture.',
      pairing: 'texture-spray',
      pairingWhy: 'extra root lift, volume or styling support underneath',
      aliases: ['grooming clay', 'grooming', 'strong clay', 'firm clay']
    },
    'matte-clay': {
      name: '4U Matte Clay',
      handle: 'matte-clay',
      sku: '4U-MC-100',
      size: '100ml',
      priceFallback: '£18',
      badge: '',
      hold: 'Medium',
      holdLevel: 'medium',
      finish: 'True matte',
      finishPlain: 'true matte — clean, no shine',
      galleryHold: 'Strong',
      galleryFinish: 'Matte',
      waterSoluble: true,
      lengths: ['very-short', 'short', 'medium'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['skin-fade', 'crop', 'structured', 'clean-matte', 'natural-matte', 'short-matte', 'messy'],
      summary: 'Best for short, thick or stubborn hair that needs a very dry, matte finish — textured crops, choppy styles, skin fades and short messy looks. Less suited to longer hair where the hold can feel too heavy.',
      storefrontCopy: 'Medium-hold matte clay for clean, natural-looking styles with a true matte finish.',
      recommendWhen: ['true matte', 'short thick hair', 'stubborn hair', 'skin fade', 'textured crop', 'short messy', 'extreme dry matte'],
      avoidWhen: ['high shine', 'wet look', 'longer flowing hair', 'curl cream routine'],
      application: [
        'Use a small amount on dry hair.',
        'Warm thoroughly between the palms.',
        'Work through and shape — build gradually for a clean matte set.'
      ],
      tip: 'Less is more for a true matte finish — over-applying can look heavy.',
      pairing: 'texture-spray',
      pairingWhy: 'extra root lift when hair sits flat',
      aliases: ['matte clay', 'true matte', 'dry clay']
    },
    'defining-cream': {
      name: '4U Defining Cream',
      handle: 'defining-cream',
      sku: '',
      size: '100ml',
      priceFallback: '£18',
      badge: '',
      hold: 'Strong',
      holdLevel: 'strong',
      finish: 'Light / natural shine',
      finishPlain: 'a little healthy-looking shine',
      galleryHold: 'Strong',
      galleryFinish: 'Natural Shine',
      waterSoluble: true,
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['side-part', 'combed', 'polished', 'professional', 'neat', 'office'],
      summary: 'Strong hold with a light shine — keeps hair in place for neater, more polished styles (side parts, combed looks, work-ready finish). Not for curl definition — use Curl Cream for curly or wavy hair.',
      storefrontCopy: 'For a strong hold with a light shine, great for keeping your hair in place.',
      recommendWhen: ['strong hold with shine', 'side part', 'polished', 'office', 'neat control'],
      avoidWhen: ['ultra-matte dry finish', 'messy textured crop', 'dedicated curl definition', 'curly hair', 'wavy curls', 'frizz'],
      application: [
        'Use on dry or slightly damp hair.',
        'Warm a small amount and distribute from back to front.',
        'Finish with a comb for a neat look, or fingers for a softer edge.'
      ],
      tip: 'Apply evenly, then comb through for a clean professional side part.',
      pairing: 'texture-spray',
      pairingWhy: 'more lift before the cream if hair sits flat',
      aliases: ['defining cream', 'definition cream', 'shine cream', 'defining']
    },
    'texture-paste': {
      name: '4U Texture Paste',
      handle: 'texture-paste',
      sku: '4U-TP-100',
      size: '100ml',
      priceFallback: '£18',
      badge: 'Best Seller',
      hold: 'Soft / flexible',
      holdLevel: 'flexible',
      finish: 'Natural',
      finishPlain: 'natural finish with free movement',
      galleryHold: 'Soft',
      galleryFinish: 'Natural Shine',
      waterSoluble: true,
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['relaxed', 'layered', 'curtains', 'flow', 'everyday', 'reworkable', 'natural', 'loose'],
      summary: 'Best-seller texture paste for a looser look with a natural finish — leaves hair free for movement. Water-soluble and the wax-like option in the range.',
      storefrontCopy: 'Great for a looser look with a natural finish, leaving your hair free for movement.',
      recommendWhen: ['movement', 'natural finish', 'loose look', 'reshape during the day', 'wax alternative'],
      avoidWhen: ['rigid all-day helmet hold', 'high-shine slicked look'],
      application: [
        'Warm a small amount between your palms.',
        'Work through dry or towel-dried hair.',
        'Style with fingers for separation and movement.'
      ],
      tip: 'Avoid heavy application at the roots if you want soft flow — work mid-lengths and ends. Washes out easily with normal shampoo.',
      pairing: 'texture-spray',
      pairingWhy: 'extra lift and a fuller “texture combo”',
      aliases: ['texture paste', 'paste', 'wax', 'best seller', 'bestseller'],
      note: 'Customers often say “wax” — Texture Paste is the flexible natural option (no separate wax SKU). Water-soluble.'
    },
    'texture-paste-travel-size-15ml': {
      name: '4U Texture Paste 15ml',
      handle: 'texture-paste-travel-size-15ml',
      sku: '4U-TP-015',
      size: '15ml',
      priceFallback: '£5',
      badge: 'Travel',
      hold: 'Soft / flexible',
      holdLevel: 'flexible',
      finish: 'Natural',
      finishPlain: 'natural finish with free movement',
      galleryHold: 'Soft',
      galleryFinish: 'Natural Shine',
      waterSoluble: true,
      travelSize: true,
      fullSizeHandle: 'texture-paste',
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['relaxed', 'layered', 'curtains', 'flow', 'everyday', 'reworkable', 'natural', 'loose'],
      summary: 'Travel-size Texture Paste (15ml) — same soft, natural finish as the 100ml jar, sized for trips and cabin bags.',
      storefrontCopy: 'Travel-size texture paste with a natural finish — same formula as the full jar.',
      recommendWhen: ['travel', 'mini', '15ml', 'cabin bag', 'try size'],
      avoidWhen: ['want full jar value', 'rigid all-day helmet hold'],
      application: [
        'Warm a small amount between your palms.',
        'Work through dry or towel-dried hair.',
        'Style with fingers for separation and movement.'
      ],
      tip: 'Same formula as the 100ml Texture Paste — start tiny; a 15ml tin goes further than you’d think.',
      pairing: 'texture-spray',
      pairingWhy: 'extra lift and a fuller “texture combo”',
      aliases: ['texture paste 15ml', 'paste travel', 'paste mini', 'travel paste', '15ml paste']
    },
    'grooming-clay-travel-size-15ml': {
      name: '4U Grooming Clay 15ml',
      handle: 'grooming-clay-travel-size-15ml',
      sku: '4U-GC-015',
      size: '15ml',
      priceFallback: '£5',
      badge: 'Travel',
      hold: 'Strong / Firm',
      holdLevel: 'strong',
      finish: 'Matte / low shine',
      finishPlain: 'matte with little to no shine',
      galleryHold: 'Firm',
      galleryFinish: 'Low Shine',
      waterSoluble: true,
      travelSize: true,
      fullSizeHandle: 'grooming-clay',
      lengths: ['very-short', 'short', 'medium'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['textured-crop', 'messy', 'quiff', 'short-matte', 'skin-fade', 'structured', 'professional', 'side-part-matte'],
      summary: 'Travel-size Grooming Clay (15ml) — strong hold, low shine, built for structured styles on the go.',
      storefrontCopy: 'Travel-size grooming clay with a matte finish and strong hold.',
      recommendWhen: ['travel', 'mini', '15ml', 'cabin bag'],
      avoidWhen: ['high shine polished look', 'want full jar'],
      application: [
        'Start with dry or almost-dry hair.',
        'Warm a small amount between the palms.',
        'Work from the back towards the front, then use fingertips for separation and texture.'
      ],
      tip: 'Same formula as the 100ml Grooming Clay — cabin-bag friendly at 15ml.',
      pairing: 'texture-spray',
      pairingWhy: 'extra root lift, volume or styling support underneath',
      aliases: ['grooming clay 15ml', 'grooming travel', 'grooming mini', 'travel clay', '15ml clay']
    },
    'matte-clay-travel-size-15ml': {
      name: '4U Matte Clay 15ml',
      handle: 'matte-clay-travel-size-15ml',
      sku: '4U-MC-015',
      size: '15ml',
      priceFallback: '£5',
      badge: 'Travel',
      hold: 'Medium',
      holdLevel: 'medium',
      finish: 'True matte',
      finishPlain: 'true matte — clean, no shine',
      galleryHold: 'Strong',
      galleryFinish: 'Matte',
      waterSoluble: true,
      travelSize: true,
      fullSizeHandle: 'matte-clay',
      lengths: ['very-short', 'short', 'medium'],
      patterns: ['straight', 'wavy'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['skin-fade', 'crop', 'structured', 'clean-matte', 'natural-matte', 'short-matte', 'messy'],
      summary: 'Travel-size Matte Clay (15ml) — true matte finish for short, textured styles when you’re away from home.',
      storefrontCopy: 'Travel-size matte clay for clean, natural-looking styles.',
      recommendWhen: ['travel', 'mini', '15ml', 'cabin bag', 'true matte travel'],
      avoidWhen: ['high shine', 'want full jar'],
      application: [
        'Use a small amount on dry hair.',
        'Warm thoroughly between the palms.',
        'Work through and shape — build gradually for a clean matte set.'
      ],
      tip: 'Same formula as the 100ml Matte Clay — ideal for trips if you want a dry matte finish.',
      pairing: 'texture-spray',
      pairingWhy: 'extra root lift when hair sits flat',
      aliases: ['matte clay 15ml', 'matte travel', 'matte mini', '15ml matte']
    },
    'defining-cream-travel-size-15ml': {
      name: '4U Defining Cream 15ml',
      handle: 'defining-cream-travel-size-15ml',
      sku: '4U-DC-015',
      size: '15ml',
      priceFallback: '£5',
      badge: 'Travel',
      hold: 'Strong',
      holdLevel: 'strong',
      finish: 'Light / natural shine',
      finishPlain: 'a little healthy-looking shine',
      galleryHold: 'Strong',
      galleryFinish: 'Natural Shine',
      waterSoluble: true,
      travelSize: true,
      fullSizeHandle: 'defining-cream',
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['side-part', 'combed', 'polished', 'professional', 'neat', 'office'],
      summary: 'Travel-size Defining Cream (15ml) — strong hold with light shine for polished styles on the road.',
      storefrontCopy: 'Travel-size defining cream for a strong hold with a light shine.',
      recommendWhen: ['travel', 'mini', '15ml', 'cabin bag', 'polished travel'],
      avoidWhen: ['ultra-matte dry finish', 'want full jar'],
      application: [
        'Use on dry or slightly damp hair.',
        'Warm a small amount and distribute from back to front.',
        'Finish with a comb for a neat look, or fingers for a softer edge.'
      ],
      tip: 'Same formula as the 100ml Defining Cream — neat control in a cabin-friendly tin.',
      pairing: 'texture-spray',
      pairingWhy: 'more lift before the cream if hair sits flat',
      aliases: ['defining cream 15ml', 'cream travel', 'cream mini', '15ml cream', 'travel cream']
    },
    'texture-spray': {
      name: '4U Texture Spray',
      handle: 'texture-spray',
      sku: '4U-TS-250',
      size: '250ml',
      priceFallback: '£16',
      badge: '',
      hold: 'High (2-in-1 style + finish)',
      holdLevel: 'flexible',
      finish: 'Soft & airy / natural texture',
      finishPlain: 'soft, airy texture — not crunchy',
      galleryHold: 'High',
      galleryFinish: 'Soft & Airy',
      waterSoluble: true,
      lengths: ['very-short', 'short', 'medium', 'long'],
      patterns: ['straight', 'wavy', 'curly'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['volume', 'lift', 'prep', 'texture', 'reworkable', 'anti-crunch', '2-in-1'],
      summary: 'The ultimate 2-in-1 spray — style your hair and hold the finished look. High volume / texture, soft & airy finish, great for all hair types. Use as prep under clay/paste/cream or as a finisher.',
      storefrontCopy: 'The ultimate 2 in 1 spray, perfect for styling your hair and holding your finished look. Great for all hair types.',
      recommendWhen: ['volume', 'lift', '2-in-1', 'all hair types', 'prep', 'finishing spray alternative', 'not crunchy'],
      avoidWhen: ['want only a heavy clay with zero spray'],
      application: [
        'Spray lightly from roughly 20–25 cm away.',
        'Use on towel-dried hair to style, or on dry hair to set a finished look.',
        'Focus on the roots for volume or mid-lengths for texture. Layer a clay/paste/cream after if you want more shape.'
      ],
      tip: 'More flexible and reworkable than a stiff classic hairspray — ideal in a texture combo with paste or clay.',
      role: 'prep',
      pairing: null,
      pairingWhy: '',
      aliases: ['texture spray', 'spray', 'hairspray', 'finishing spray', '2 in 1', '2-in-1', 'volume spray']
    },
    'texture-spray-travel-size-50ml': {
      name: '4U Texture Spray 50ml',
      handle: 'texture-spray-travel-size-50ml',
      sku: '4U-TS-050',
      size: '50ml',
      priceFallback: '£6',
      badge: 'Travel',
      hold: 'High (2-in-1 style + finish)',
      holdLevel: 'flexible',
      finish: 'Soft & airy / natural texture',
      finishPlain: 'soft, airy texture — not crunchy',
      galleryHold: 'High',
      galleryFinish: 'Soft & Airy',
      waterSoluble: true,
      travelSize: true,
      fullSizeHandle: 'texture-spray',
      lengths: ['very-short', 'short', 'medium', 'long'],
      patterns: ['straight', 'wavy', 'curly'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['volume', 'lift', 'prep', 'texture', 'reworkable', 'anti-crunch', '2-in-1'],
      summary: 'Travel-size Texture Spray (50ml) — same 2-in-1 style + finish as the 250ml bottle, sized for trips and cabin bags.',
      storefrontCopy: 'Travel-size 2-in-1 texture spray — style and hold your finished look on the go.',
      recommendWhen: ['travel', 'mini', '50ml', 'cabin bag', 'travel spray'],
      avoidWhen: ['want full 250ml bottle value'],
      application: [
        'Spray lightly from roughly 20–25 cm away.',
        'Use on towel-dried hair to style, or on dry hair to set a finished look.',
        'Focus on the roots for volume or mid-lengths for texture.'
      ],
      tip: 'Same formula as the 250ml Texture Spray — a little mist goes a long way in the 50ml bottle.',
      role: 'prep',
      pairing: null,
      pairingWhy: '',
      aliases: ['texture spray 50ml', 'spray 50ml', 'travel spray', '50ml spray', 'mini spray', 'texture spray travel']
    },
    'curl-cream': {
      name: '4U Curl Cream',
      handle: 'curl-cream',
      sku: '4U-CC-100',
      size: '100ml',
      priceFallback: '£16',
      badge: 'New',
      hold: 'Medium',
      holdLevel: 'light',
      finish: 'Hydrated curls (wet look or matte textured)',
      finishPlain: 'hydrated definition — wet look or broken-up matte texture',
      galleryHold: 'Medium',
      galleryFinish: 'Hydrated Curls',
      waterSoluble: true,
      lengths: ['short', 'medium', 'long'],
      patterns: ['wavy', 'curly', 'coily'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['curl', 'frizz', 'definition', 'scrunch', 'diffuse', 'wet-look'],
      summary: 'Curl cream for waves and curls — apply generously to wet or damp hair, scrunch into shape, then air-dry or diffuse. Leave undisturbed for a wet look, or break up dry curls by hand for a matte textured finish.',
      storefrontCopy: 'Apply a generous amount to wet or damp hair. Distribute evenly and scrunch curls into shape. Air dry or diffuse. Wet look: leave undisturbed while drying. Matte textured finish: once dry, gently break up the curls with your hands.',
      recommendWhen: ['curl definition', 'waves', 'frizz control', 'wet look', 'light hold wet look', 'diffuse', 'scrunch'],
      avoidWhen: ['ultra-matte dry clay style', 'maximum rigid helmet hold'],
      application: [
        'Apply a small to generous amount to wet or damp hair.',
        'Distribute evenly and scrunch or smooth into shape.',
        'Air-dry or diffuse. For a soft wet look — leave undisturbed while drying. For a matte textured finish — once dry, gently break up with your hands.'
      ],
      tip: 'For a soft wet look with light hold, use a small amount through damp hair and air-dry — shine and definition without going stiff or crunchy.',
      role: 'curl',
      pairing: null,
      pairingAfterDry: true,
      pairingWhy: 'after fully dry, a tiny amount of finishing product for separation',
      aliases: ['curl cream', 'curling cream', 'curl', 'waves cream']
    },
    '4u-4her-texture-spray': {
      name: '4U 4HER Texture Spray',
      handle: '4u-4her-texture-spray',
      sku: '',
      size: '250ml',
      priceFallback: '£16',
      badge: '4U 4HER',
      hold: '2-in-1 style + finish',
      holdLevel: 'flexible',
      finish: 'Glossy / finished set',
      finishPlain: 'glossy finish with hold for a completed style',
      galleryHold: 'High',
      galleryFinish: 'Glossy',
      waterSoluble: true,
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight', 'wavy', 'curly'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: ['volume', 'blow-dry', 'finish', '2-in-1'],
      summary: 'Dedicated 4HER 2-in-1 texture spray — style, finish and hold. Quick-drying, humidity-resistant, strong for blow-dry support with a glossy finished set.',
      storefrontCopy: 'For styling and finishing — advanced, quick-drying texture spray with high performance and humidity resistance. Blow-drying support with a glossy finish; sets a completed hairstyle.',
      recommendWhen: ['4her', 'glossy finish', 'humidity', 'blow dry support', '2-in-1 for her'],
      avoidWhen: ['want ultra-matte clay only'],
      application: [
        'Apply evenly to towel-dried hair and style as desired.',
        'Or hold about 25cm away and use as a finishing spray on dry hair.'
      ],
      tip: 'Part of the 4HER line — same vegan / cruelty-free / paraben-free / sulphate-free standards as the core range.',
      role: 'prep',
      pairing: null,
      hiddenUnless4her: true,
      aliases: ['4her', '4 her', '4u 4her', 'her texture spray', 'pink spray', '4her spray']
    }
  };

  /* Mark finishers for pairing logic */
  ['grooming-clay', 'matte-clay', 'defining-cream', 'texture-paste',
   'grooming-clay-travel-size-15ml', 'matte-clay-travel-size-15ml', 'defining-cream-travel-size-15ml', 'texture-paste-travel-size-15ml'].forEach((h) => {
    if (PRODUCT_KB[h]) PRODUCT_KB[h].role = 'finish';
  });

  /* Brand facts (merged with Liquid config) */
  const BRAND_FACTS = {
    tagline: 'Your Style. Your Way.',
    positioning: 'Professional-grade styling products, crafted by a barber for barbers.',
    rangeLine: 'A full range of professional finishes. One standard of quality. Find your perfect hold.',
    founderTitle: 'Crafted By Bradley Connellan',
    founderBio: 'Bradley Connellan has been cutting and styling a wide range of hair types since a young age. He started barbering in a salon straight out of school, worked in multiple salons from 16 to 24, then freelanced with private bookings — and used that chair experience to create 4U.',
    claims: [
      'Paraben-free',
      'Sulphate-free',
      'Cruelty-free',
      'Vegan formulation',
      'Responsibly sourced',
      'Made in the UK',
      'Water-soluble formulas',
      'Barber approved'
    ],
    claimDetails: {
      'Paraben-free': 'No synthetic preservatives — gentler on scalp and skin.',
      'Sulphate-free': 'No harsh detergents like SLS/SLES — cleanses without stripping natural oils.',
      'Cruelty-free': 'Never tested on animals.',
      'Vegan formulation': 'Vegan formulation across the range.',
      'Responsibly sourced': 'Ingredients from sustainable, fair-trade suppliers where specified.',
      'Made in the UK': 'Manufactured to strict UK quality and safety standards.',
      'Water-soluble formulas': 'Designed to wash out with standard shampoo — no greasy buildup when used correctly.',
      'Barber approved': 'Built from real barber-chair experience, not trend marketing alone.'
    },
    trustpilotLabel: 'Excellent',
    testimonial: {
      quote: 'Best wax I\'ve used that gives hold on my hair all night couldn\'t recommend enough!!',
      author: 'Lee Boys',
      product: 'texture-paste'
    },
    notSold: ['gel', 'pomade', 'mousse', 'shampoo', 'conditioner', 'beard oil', 'beard balm', 'gift cards'],
    sizes: 'Full-size jars/creams are 100ml; travel minis are 15ml (Texture Paste, Grooming Clay, Matte Clay, Defining Cream). Texture Spray is 250ml (travel 50ml).',
    collectionOrder: ['curl-cream', 'grooming-clay', 'defining-cream', 'texture-paste', 'matte-clay', 'texture-spray', 'texture-spray-travel-size-50ml', '4u-4her-texture-spray', 'texture-paste-travel-size-15ml', 'grooming-clay-travel-size-15ml', 'matte-clay-travel-size-15ml', 'defining-cream-travel-size-15ml']
  };

  /* Legacy CSV / alternate handles → canonical PRODUCT_KB keys */
  const HANDLE_ALIASES = {
    'texture-paste-15ml': 'texture-paste-travel-size-15ml',
    'grooming-clay-15ml': 'grooming-clay-travel-size-15ml',
    'matte-clay-15ml': 'matte-clay-travel-size-15ml',
    'defining-cream-15ml': 'defining-cream-travel-size-15ml',
    'texture-spray-50ml': 'texture-spray-travel-size-50ml',
    'texture-spray-15ml': 'texture-spray-travel-size-50ml'
  };

  function resolveKbHandle(handle) {
    if (!handle) return null;
    if (PRODUCT_KB[handle]) return handle;
    if (HANDLE_ALIASES[handle] && PRODUCT_KB[HANDLE_ALIASES[handle]]) return HANDLE_ALIASES[handle];
    if (handle.indexOf('4her') !== -1 && PRODUCT_KB['4u-4her-texture-spray']) return '4u-4her-texture-spray';
    return null;
  }

  function createLiveProductStub(live) {
    const title = live.title || live.handle;
    const name = title.indexOf('4U') === 0 ? title : ('4U ' + String(title).replace(/^4U\s+/i, ''));
    const short = String(title).replace(/^4U\s+/i, '').trim();
    return {
      name: name,
      handle: live.handle,
      sku: live.sku || '',
      size: live.size || '',
      priceFallback: live.price || '',
      priceLabel: live.price || '',
      badge: '',
      hold: 'See product page',
      holdLevel: 'medium',
      finish: 'See product page',
      finishPlain: 'see product page for finish',
      waterSoluble: true,
      lengths: ['short', 'medium', 'long'],
      patterns: ['straight', 'wavy', 'curly'],
      thicknesses: ['fine', 'medium', 'thick'],
      styles: [],
      summary: live.description || (short + ' — live from the 4U shop.'),
      storefrontCopy: live.description ? String(live.description).slice(0, 220) : '',
      recommendWhen: [],
      avoidWhen: [],
      application: live.howTo
        ? [String(live.howTo).slice(0, 280)]
        : ['See the product page for how to use.'],
      tip: 'Ask me about hold, finish, or what to pair it with — or open the product page for full details.',
      role: 'finish',
      pairing: null,
      pairingWhy: '',
      aliases: short ? [short.toLowerCase(), live.handle.replace(/-/g, ' ')] : [live.handle.replace(/-/g, ' ')],
      liveStub: true,
      available: live.available !== false
    };
  }

  function hydrateKbFromLive() {
    const list = Array.isArray(cfg.products) ? cfg.products : [];
    list.forEach((live) => {
      if (!live || !live.handle) return;
      let key = resolveKbHandle(live.handle);
      let p = key ? PRODUCT_KB[key] : null;
      if (!p) {
        /* Safety net: never hide a published Shopify product from GPT context */
        PRODUCT_KB[live.handle] = createLiveProductStub(live);
        p = PRODUCT_KB[live.handle];
        key = live.handle;
      }
      if (live.title) p.name = live.title.indexOf('4U') === 0 ? live.title : ('4U ' + live.title.replace(/^4U\s+/i, ''));
      if (live.description) p.liveDescription = live.description;
      if (live.price) p.priceLabel = live.price;
      if (live.sku) p.sku = live.sku;
      if (live.size) p.size = live.size;
      if (live.howTo) p.howToLive = live.howTo;
      if (live.ingredients) p.ingredients = live.ingredients;
      if (live.available === false) p.available = false;
      else if (p.liveStub) p.available = true;
      /* If Shopify used an alias handle, keep liveProduct() lookups working via stub redirect */
      if (key && key !== live.handle && !PRODUCT_KB[live.handle]) {
        PRODUCT_KB[live.handle] = Object.assign({}, p, { handle: live.handle, aliasOf: key });
      }
    });
  }
  hydrateKbFromLive();

  /**
   * @param {{ recommendableOnly?: boolean }} [opts]
   * recommendableOnly: exclude sold-out from buy/reco paths.
   * Knowledge/GPT context keeps sold-out SKUs so the bot never “forgets” them.
   */
  function catalogHandles(opts) {
    const recommendableOnly = !!(opts && opts.recommendableOnly);
    const order = BRAND_FACTS.collectionOrder || [];
    const keys = Object.keys(PRODUCT_KB).filter((h) => {
      const p = PRODUCT_KB[h];
      if (!p || p.aliasOf) return false;
      if (p.hiddenUnless4her && !cfg.show4her && !(cfg.products || []).some((x) => x && (x.handle === h || resolveKbHandle(x.handle) === h))) return false;
      if (recommendableOnly && p.available === false) return false;
      return true;
    });
    keys.sort((a, b) => {
      const ia = order.indexOf(a);
      const ib = order.indexOf(b);
      if (ia === -1 && ib === -1) return 0;
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
    return keys;
  }

  function visibleProductHandles() {
    return catalogHandles({ recommendableOnly: true });
  }

  function knowledgeProductHandles() {
    return catalogHandles({ recommendableOnly: false });
  }

  function lockReply(result, extra) {
    if (!result) return result;
    return Object.assign({ lockDraft: true, voicePass: true }, result, extra || {});
  }

  function warnCatalogDrift() {
    try {
      const liveHandles = (Array.isArray(cfg.products) ? cfg.products : [])
        .map((p) => p && p.handle)
        .filter(Boolean);
      const stubHandles = Object.keys(PRODUCT_KB).filter((h) => {
        const p = PRODUCT_KB[h];
        return p && p.liveStub && !p.aliasOf;
      });
      const kbOnly = Object.keys(PRODUCT_KB).filter((h) => {
        const p = PRODUCT_KB[h];
        if (!p || p.aliasOf || p.liveStub || p.hiddenUnless4her) return false;
        return !liveHandles.some((lh) => resolveKbHandle(lh) === h || lh === h);
      });
      if (stubHandles.length) {
        console.warn('[4U chat] Shopify products missing rich PRODUCT_KB (using live stubs):', stubHandles);
      }
      if (kbOnly.length && liveHandles.length) {
        console.warn('[4U chat] PRODUCT_KB entries not in live Shopify catalogue:', kbOnly);
      }
    } catch (e) { /* ignore */ }
  }
  warnCatalogDrift();

  const STYLE_MAP = [
    { re: /textured crop|messy crop|messy textured|textured messy|short messy|\bcrop\b/, style: 'textured-crop', primary: 'grooming-clay' },
    { re: /skin fade|bald fade/, style: 'skin-fade', primary: 'matte-clay' },
    { re: /messy quiff|quiff/, style: 'quiff', primary: 'grooming-clay' },
    { re: /side part|side parting|comb[- ]?over|polished side part|neat side part|office (look|style|hair)|professional (look|style|finish|side)/, style: 'side-part', primary: 'defining-cream' },
    { re: /wet look|wet\-look/, style: 'wet-look', primary: 'curl-cream' },
    { re: /side-part-matte/, style: 'side-part-matte', primary: 'grooming-clay' },
    { re: /curtain|curtains/, style: 'curtains', primary: 'texture-paste' },
    { re: /modern flow|longer movement|flowy|flowing/, style: 'flow', primary: 'texture-paste' },
    { re: /curly fringe|curl fringe/, style: 'curl', primary: 'curl-cream' },
    { re: /relaxed wavy|wavy style/, style: 'relaxed', primary: 'texture-paste' },
    { re: /messy matte|matte messy|messy.*matte|matte.*messy/, style: 'short-matte', primary: 'grooming-clay' }
  ];

  /* ========== Helpers ========== */
  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[’']/g, "'")
      .replace(/£/g, '')
      .replace(/\b4\s*u\b/g, '4u')
      .replace(/\bfour\s*u\b/g, '4u')
      .replace(/[^a-z0-9&\s'+-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * High-value vocabulary for typo repair (e.g. "wthical" → "ethical").
   * Keep terms distinctive — short common words are excluded on purpose.
   */
  const SPELL_LEXICON = [
    'ethical', 'ethics', 'ethically', 'vegan', 'cruelty', 'paraben', 'parabens',
    'sulphate', 'sulfate', 'sulphates', 'ingredients', 'ingredient', 'sustainable',
    'responsibly', 'sourced', 'environment', 'environmental', 'shipping', 'delivery',
    'founder', 'bradley', 'connellan', 'owner', 'refund', 'return', 'returns',
    'wholesale', 'discount', 'newsletter', 'grooming', 'texture', 'defining',
    'matte', 'paste', 'spray', 'cream', 'curl', 'curly', 'frizz', 'volume',
    'recommend', 'recommendation', 'product', 'products', 'hold', 'finish',
    'shine', 'natural', 'flexible', 'strong', 'medium', 'short', 'long',
    'barber', 'barbers', 'water', 'soluble', 'wash', 'application',
    'pairing', 'compare', 'difference', 'international', 'trustpilot',
    'instagram', 'tiktok', 'account', 'checkout', 'payment', 'available',
    'humidity', 'thick', 'fine', 'straight', 'wavy', 'coily', 'quiff',
    'crop', 'pomade', 'beard', 'sample', 'bundle', 'subscription', 'gift',
    'privacy', 'policy', 'policies', 'conditions', 'gdpr', 'legal'
  ];

  /* Never rewrite these — edit-distance false friends (hair→pair, made→fade, apple→apply) */
  const SPELL_PROTECTED = {
    hair: 1, hairs: 1, made: 1, make: 1, apple: 1, pay: 1, paid: 1, pays: 1, with: 1,
    want: 1, wants: 1, wax: 1, what: 1, where: 1, when: 1, which: 1, this: 1,
    that: 1, from: 1, your: 1, have: 1, more: 1, just: 1, only: 1, also: 1,
    very: 1, much: 1, need: 1, help: 1, look: 1, looks: 1, like: 1, best: 1,
    good: 1, great: 1, real: 1, here: 1, there: 1, they: 1, them: 1, then: 1,
    than: 1, some: 1, same: 1, time: 1, used: 1, use: 1, using: 1, does: 1,
    done: 1, into: 1, over: 1, under: 1, about: 1, after: 1, before: 1,
    please: 1, thanks: 1, thank: 1, hello: 1, fade: 1, pair: 1, apply: 1,
    card: 1, shop: 1, free: 1, cost: 1, price: 1, size: 1
  };

  function editDistance(a, b) {
    if (a === b) return 0;
    const m = a.length;
    const n = b.length;
    if (!m) return n;
    if (!n) return m;
    if (Math.abs(m - n) > 2) return 99;
    let prev = new Array(n + 1);
    let cur = new Array(n + 1);
    for (let j = 0; j <= n; j++) prev[j] = j;
    for (let i = 1; i <= m; i++) {
      cur[0] = i;
      for (let j = 1; j <= n; j++) {
        const cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      const tmp = prev;
      prev = cur;
      cur = tmp;
    }
    return prev[n];
  }

  function correctTypos(text) {
    const raw = normalize(text);
    if (!raw) return raw;
    const words = raw.split(' ');
    const fixed = words.map((word) => {
      if (word.length < 5) return word;
      if (SPELL_PROTECTED[word] || SPELL_LEXICON.indexOf(word) !== -1) return word;
      /* 1 edit for 5–7 letters, 2 for longer (covers wthical→ethical).
         Same first letter preferred; longer words may flip one letter at the start. */
      const maxDist = word.length >= 8 ? 2 : 1;
      let best = null;
      let bestDist = maxDist + 1;
      for (let i = 0; i < SPELL_LEXICON.length; i++) {
        const cand = SPELL_LEXICON[i];
        if (Math.abs(cand.length - word.length) > maxDist) continue;
        const d = editDistance(word, cand);
        if (d > maxDist) continue;
        const sameStart = cand[0] === word[0];
        if (!sameStart && !(word.length >= 7 && cand.length >= 7 && d === 1)) continue;
        if (d < bestDist || (d === bestDist && sameStart && best && best[0] !== word[0])) {
          bestDist = d;
          best = cand;
        }
      }
      return best ? best : word;
    });
    return fixed.join(' ');
  }

  /** Normalize + typo repair for intent / knowledge matching */
  function normalizeQuery(text) {
    let q = correctTypos(text);
    /* Short product typos the lexicon skips (3-letter tokens) */
    q = q
      .replace(/\bbest was\b/g, 'best wax')
      .replace(/\bwas for\b/g, 'wax for')
      .replace(/\b(a|the|some) was\b/g, '$1 wax')
      .replace(/\bwaxx\b/g, 'wax')
      .replace(/\bdrylook\b/g, 'dry look');
    return q;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function liveProduct(handle) {
    const list = Array.isArray(cfg.products) ? cfg.products : [];
    const direct = list.find((p) => p && p.handle === handle);
    if (direct) return direct;
    /* Match when Shopify used a legacy alias handle for this KB product */
    return list.find((p) => p && resolveKbHandle(p.handle) === handle) || null;
  }

  function productUrl(handle) {
    const live = liveProduct(handle);
    return (live && live.url) || `/products/${handle}`;
  }

  function productPrice(handle) {
    const live = liveProduct(handle);
    return (live && live.price) || '';
  }

  function productAvailable(handle) {
    const p = PRODUCT_KB[handle];
    if (p && p.available === false) return false;
    const live = liveProduct(handle);
    return !live || live.available !== false;
  }

  /* ========== Session consultation state ========== */
  const session = {
    length: null,
    pattern: null,
    thickness: null,
    finish: null,
    hold: null,
    style: null,
    wantWaxOrClay: false,
    wantMovement: false,
    wantTravel: false,
    trueMatte: false,
    questionsAsked: 0,
    lastHandle: null
  };

  function resetSessionSoft() {
    /* Keep memory within the open chat; only clear on explicit restart */
  }

  /* ========== Attribute parsing ========== */
  function parseAttributes(query) {
    const q = normalize(query);
    const found = {};

    if (/very short|skin fade|buzz|number [01]|grade [01]/.test(q)) found.length = 'very-short';
    else if (/\bshort\b|crop|crew|fade/.test(q)) found.length = 'short';
    else if (/medium[- ]?long|mid length|shoulder/.test(q)) found.length = 'long';
    else if (/\bmedium hold\b|\bmedium[- ]hold\b/.test(q)) { /* hold handled below — not length */ }
    else if (/\bmedium\b/.test(q)) found.length = 'medium';
    else if (/\blong\b|longer/.test(q)) found.length = 'long';

    if (/coil|coily|afro/.test(q)) found.pattern = 'coily';
    else if (/curl|curly|frizz|coily/.test(q)) {
      found.pattern = /coily/.test(q) ? 'coily' : 'curly';
      if (!found.style) found.style = 'curl';
    }
    else if (/wav(y|e)/.test(q)) found.pattern = 'wavy';
    else if (/straight/.test(q)) found.pattern = 'straight';

    if (/\bfine\b|flat|thin hair/.test(q)) found.thickness = 'fine';
    else if (/\bthick\b|coarse|dense/.test(q)) found.thickness = 'thick';
    else if (/\bmedium\b (hair|thickness|density)/.test(q)) found.thickness = 'medium';

    /* Finish — dry/matte first; “light shine + movement” = paste; wet look is its own path */
    const wantsMovement = /\bmovement\b|flowy|flowing|loose look|free movement|reworkable|reshape during|more movement/.test(q);
    const wantsNeatShine = /polished|side part|side parting|neat|office|combed|slick|professional look/.test(q);
    const wantsWetLook = /wet look|wet\-look|soft wet|shiny wet/.test(q);
    /* Don’t treat the product name “matte clay” as a finish ask */
    const wantsMatteFinish = /no shine|zero shine|without shine|don't want shine|dont want shine|no gloss|ultra[- ]?dry|dry look|dry finish|dry matte|dull finish|not shiny|\bmatte finish\b/.test(q)
      || (/\bmatte\b/.test(q) && !/matte clay/.test(q));

    if (wantsWetLook) {
      found.finish = 'wet';
      found.style = 'wet-look';
    } else if (wantsMatteFinish) {
      found.finish = 'matte';
    } else if (wantsMovement && !wantsNeatShine && /light shine|a little shine|little natural shine|natural shine|some shine|bit of shine/.test(q)) {
      found.finish = 'natural';
      found.style = 'flow';
      found.wantMovement = true;
    } else if (/light shine|a little shine|little natural shine|some shine|bit of shine|a bit of shine|gloss|polished|healthy[- ]looking shine|\bshiny\b|\bshine\b/.test(q)) {
      found.finish = 'shine';
    } else if (/natural finish|natural look|natural movement|not glossy/.test(q)) {
      found.finish = 'natural';
    }

    /* Hold — bare “strong” / “firm” counts (e.g. “strong with shine”) */
    if (/maximum hold|max hold|strongest|rigid|all day hold|all\-day|stay in place|keeps? (it )?in place|won't move|\bmaximum\b/.test(q)) found.hold = 'maximum';
    else if (/strong hold|firm hold|lots of hold|\bstrong\b|\bfirm\b/.test(q)) found.hold = 'strong';
    else if (/medium hold|soft hold|light hold|flexible|rework|movement|not stuck|not rigid/.test(q)) found.hold = 'flexible';

    if (/\bwax\b/.test(q)) found.wantWaxOrClay = true;
    /* “clay” as a category ask — not when naming Grooming/Matte Clay */
    if (/\bclay\b/.test(q) && !/grooming clay|matte clay/.test(q)) found.wantWaxOrClay = true;
    if (/travel|15\s*ml|50\s*ml|mini size|mini jar|cabin bag|hand luggage|airport|flying|on the (go|road)/.test(q)) {
      found.wantTravel = true;
    }
    if (wantsMovement && !wantsNeatShine && !wantsWetLook) {
      found.wantMovement = true;
      if (!found.style) found.style = 'flow';
      if (!found.hold || found.hold === 'maximum') found.hold = 'flexible';
      if (found.finish === 'shine') found.finish = 'natural';
    }

    /* Strong + shine (without movement) → neat cream path */
    if ((found.hold === 'strong' || found.hold === 'maximum') && found.finish === 'shine' && !found.wantMovement) {
      found.style = found.style || 'side-part';
    }

    STYLE_MAP.forEach((row) => {
      if (row.re.test(q)) found.style = row.style;
    });
    if (/volume|lift|root/.test(q)) found.style = found.style || 'volume';
    if (/frizz|definition/.test(q) && /curl|wav/.test(q)) found.style = 'curl';
    if (/matte finish/.test(q) && !found.finish) found.finish = 'matte';
    if (/strong hold matte|matte.*strong|strong.*matte|strong hold.*dry|dry.*strong hold/.test(q)) {
      found.finish = found.finish || 'matte';
      found.hold = found.hold || 'strong';
    }
    /* Side part + dry/matte → clay path, not cream */
    if (found.style === 'side-part' && found.finish === 'matte') {
      found.style = 'side-part-matte';
    }
    return found;
  }

  function mergeSession(attrs, query) {
    const q = normalize(query);

    /* Explicit finish/hold in this message wins over leftover chat state */
    if (attrs.finish) session.finish = attrs.finish;
    if (attrs.hold) session.hold = attrs.hold;

    /* New curl/frizz goal — drop leftover matte/short-style bias */
    if (attrs.pattern === 'curly' || attrs.pattern === 'coily' || /frizz|curl definition/.test(q)) {
      if (!attrs.finish) session.finish = null;
      if (!attrs.hold) session.hold = null;
      session.style = attrs.style || 'curl';
    }

    /* Volume / anti-crunch consult — Texture Spray path, clear matte bias */
    if ((/flat|crunch|hairspray|volume|lift/.test(q)) && !/matte|crop|fade|quiff|clay|dry look|dry finish/.test(q)) {
      if (!attrs.finish) session.finish = null;
      if (!attrs.hold) session.hold = 'flexible';
      session.style = attrs.style || 'volume';
    }

    /* Natural movement / not stuck — paste path (not when they asked dry/matte/wet) */
    if (
      (attrs.wantMovement || /not stuck|natural movement|\bmovement\b|more movement|reshape|rework|medium[- ]?long|medium long|loose look/.test(q)) &&
      !/matte|dry look|dry finish|side part|side parting|polished|neat|office|wet look/.test(q)
    ) {
      session.hold = 'flexible';
      session.finish = 'natural';
      session.style = attrs.style || 'flow';
      session.wantMovement = true;
      session.trueMatte = false;
    }

    /* Soft wet look — curl cream path */
    if (attrs.style === 'wet-look' || attrs.finish === 'wet' || /wet look|wet\-look/.test(q)) {
      session.style = 'wet-look';
      session.finish = 'wet';
      if (!attrs.hold) session.hold = attrs.hold || session.hold || 'flexible';
    }

    Object.keys(attrs).forEach((k) => {
      if (k === 'wantWaxOrClay' || k === 'wantMovement' || k === 'wantTravel') {
        session[k] = !!attrs[k];
        return;
      }
      if (attrs[k]) session[k] = attrs[k];
    });
    if (/true matte/.test(q)) session.trueMatte = true;
    else if (attrs.finish && attrs.finish !== 'matte') session.trueMatte = false;
  }

  function knownCount() {
    return ['length', 'pattern', 'thickness', 'finish', 'hold', 'style'].filter((k) => session[k]).length;
  }

  function confidence() {
    const n = knownCount();
    if (session.style && (session.length || session.finish || session.hold || session.pattern)) return 'high';
    if (n >= 3) return 'high';
    if (n >= 2) return 'medium';
    return 'low';
  }

  /* ========== Decision engine (Guide §7) ========== */
  function scoreProduct(handle) {
    const p = PRODUCT_KB[handle];
    if (!p) return -999;

    /* Travel minis share formula scoring with their 100ml twin */
    if (p.fullSizeHandle) {
      let score = scoreProduct(p.fullSizeHandle);
      score += session.wantTravel ? 55 : -100;
      return score;
    }

    let score = 0;
    if (session.wantTravel && ['grooming-clay', 'matte-clay', 'defining-cream', 'texture-paste', 'texture-spray'].includes(handle)) {
      score -= 40;
    }

    if (session.length && p.lengths.includes(session.length)) score += 30;
    else if (session.length && !p.lengths.includes(session.length)) score -= 25;

    if (session.pattern && p.patterns.includes(session.pattern)) score += 28;
    else if (session.pattern === 'curly' || session.pattern === 'coily') {
      if (handle === 'curl-cream') score += 40;
      else score -= 20;
    }

    if (session.thickness && p.thicknesses.includes(session.thickness)) score += 12;

    if (session.finish === 'matte') {
      if (handle === 'grooming-clay') score += 42;
      else if (handle === 'matte-clay') score += 34;
      else if (handle === 'defining-cream') score -= 50;
      else if (handle === 'texture-paste') score -= 12;
      else if (handle === 'curl-cream') score -= 25;
    } else if (session.finish === 'wet') {
      if (handle === 'curl-cream') score += 48;
      else if (handle === 'defining-cream') score += 8;
      else if (handle === 'grooming-clay' || handle === 'matte-clay') score -= 35;
    } else if (session.finish === 'shine') {
      /* Polished shine → cream; soft shine + movement handled as natural above */
      if (handle === 'defining-cream') score += 32;
      else if (handle === 'texture-paste') score += 10;
      else if (handle === 'matte-clay') score -= 25;
      else if (handle === 'grooming-clay') score -= 10;
    } else if (session.finish === 'natural') {
      if (handle === 'texture-paste') score += 38;
      else if (handle === 'texture-spray') score += 18;
      else if (handle === 'defining-cream') score -= 5;
    }

    if (session.hold === 'maximum') {
      /* Live range: Grooming Clay = strongest hold on short; long + shine → cream */
      if (session.length === 'long' || session.length === 'medium') {
        if (session.finish === 'shine' && handle === 'defining-cream') score += 45;
        else if (session.finish === 'matte' && handle === 'texture-paste') score += 20;
        else if (handle === 'grooming-clay') score += 8;
        else if (handle === 'defining-cream') score += 28;
      } else {
        if (handle === 'grooming-clay') score += 40;
        else if (handle === 'matte-clay') score += 18;
        else if (handle === 'defining-cream') score += 12;
        else if (handle === 'texture-paste' || handle === 'curl-cream') score -= 20;
      }
    } else if (session.hold === 'strong') {
      if (handle === 'grooming-clay' || handle === 'defining-cream') score += 28;
      else if (handle === 'matte-clay') score += 14;
    } else if (session.hold === 'flexible' || session.hold === 'light') {
      /* Flexible + matte/dry look → still prefer clay (not cream/paste shine path) */
      if (session.finish === 'matte') {
        /* “true matte + medium/light hold” → Matte Clay; strong matte stays Grooming Clay */
        if (handle === 'matte-clay') score += 36;
        else if (handle === 'grooming-clay') score += 22;
        else if (handle === 'texture-paste') score += 8;
        else if (handle === 'defining-cream') score -= 30;
      } else if (session.finish === 'wet' || session.style === 'wet-look') {
        if (handle === 'curl-cream') score += 40;
        else if (handle === 'texture-paste') score += 10;
      } else {
        if (handle === 'texture-paste' || handle === 'curl-cream' || handle === 'texture-spray') score += 28;
        else if (handle === 'matte-clay') score -= 8;
      }
    }

    if (session.style) {
      if (p.styles.includes(session.style)) score += 35;
      STYLE_MAP.forEach((row) => {
        if (row.style === session.style && row.primary === handle) score += 25;
      });
    }

    /* Soft wet look (esp. short + light hold) → Curl Cream */
    if (session.style === 'wet-look' || session.finish === 'wet') {
      if (handle === 'curl-cream') score += 45;
      else if (handle === 'defining-cream') score -= 15;
      else if (handle === 'grooming-clay' || handle === 'matte-clay') score -= 30;
    }
    if ((session.length === 'short' || session.length === 'very-short') && (session.style === 'wet-look' || session.finish === 'wet') && handle === 'curl-cream') {
      score += 25;
    }

    /* Movement / flow → Texture Paste (not Defining Cream) */
    if (session.wantMovement || session.style === 'flow' || session.style === 'natural' || session.style === 'curtains') {
      if (handle === 'texture-paste') score += 45;
      else if (handle === 'defining-cream') score -= 40;
      else if (handle === 'grooming-clay' || handle === 'matte-clay') score -= 15;
    }

    /* Wax ask: short/medium dry → Grooming Clay; long no-shine → Texture Paste */
    if (session.wantWaxOrClay && session.finish === 'matte') {
      if (session.length === 'long' || session.length === 'medium') {
        if (handle === 'texture-paste') score += 50;
        if (handle === 'grooming-clay') score -= 30;
        if (handle === 'defining-cream') score -= 40;
      } else {
        if (handle === 'grooming-clay') score += 35;
        if (handle === 'defining-cream') score -= 40;
      }
    }
    if (session.wantWaxOrClay && !session.finish && handle === 'texture-paste') score += 20;

    /* Explicit “true matte” → Matte Clay */
    if (session.finish === 'matte' && session.trueMatte && handle === 'matte-clay') score += 30;
    if (session.finish === 'matte' && session.trueMatte && handle === 'grooming-clay') score -= 8;

    /* Side parting + dry/matte → Grooming Clay (not Defining Cream) */
    if (session.style === 'side-part-matte' || (session.style === 'side-part' && session.finish === 'matte')) {
      if (handle === 'grooming-clay') score += 55;
      if (handle === 'defining-cream') score -= 45;
      if (handle === 'matte-clay') score += 15;
    }

    /* Decision table boosts */
    if (session.length === 'short' && session.finish === 'matte' && handle === 'grooming-clay') score += 20;
    if ((session.length === 'very-short' || session.length === 'short') && session.finish === 'matte' && handle === 'matte-clay') score += 22;
    if ((session.length === 'very-short' || session.length === 'short') && session.hold === 'maximum' && session.finish === 'matte' && handle === 'grooming-clay') score += 28;
    if ((session.length === 'medium' || session.length === 'long') && session.hold === 'flexible' && session.finish !== 'matte' && handle === 'texture-paste') score += 25;
    if ((session.length === 'medium' || session.length === 'long') && session.finish === 'shine' && !session.wantMovement && handle === 'defining-cream') score += 25;
    if ((session.length === 'medium' || session.length === 'long') && session.finish === 'matte' && handle === 'texture-paste') score += 28;
    if ((session.length === 'medium' || session.length === 'long') && session.finish === 'matte' && handle === 'grooming-clay') score -= 20;
    if (session.thickness === 'fine' && /volume|lift|flat/.test(session.style || '') && handle === 'texture-spray') score += 30;
    if ((session.pattern === 'curly' || session.pattern === 'coily' || session.pattern === 'wavy') && /frizz|curl|definition/.test((session.style || '') + (session.pattern || '')) && handle === 'curl-cream') score += 30;

    if (session.thickness === 'fine' && handle === 'texture-spray') score += 8;
    if (session.style === 'volume' && handle === 'texture-spray') score += 35;
    if (session.style === 'volume' && /clay|matte-clay|grooming/.test(handle)) score -= 20;
    if (session.style === 'curl' && handle === 'curl-cream') score += 40;
    if (session.style === 'curl' && handle !== 'curl-cream' && handle !== 'texture-spray') score -= 15;

    return score;
  }

  function pickProduct() {
    const ranked = visibleProductHandles()
      .filter((h) => h !== '4u-4her-texture-spray') /* core consult stays on main range */
      .map((h) => ({ handle: h, score: scoreProduct(h) }))
      .sort((a, b) => b.score - a.score);
    return ranked[0];
  }

  /* ========== Subtle pairing (prep + finish) ========== */
  function shortProductName(handle) {
    const p = PRODUCT_KB[handle];
    return p ? p.name.replace(/^4U\s+/i, '') : handle;
  }

  function pairLink(handle) {
    const p = PRODUCT_KB[handle];
    if (!p || !productAvailable(handle)) return '';
    return `<a href="${SHOP}${productUrl(handle)}">${escapeHtml(shortProductName(handle))}</a>`;
  }

  /** Best finishing product to sit with Texture Spray / after Curl Cream */
  function pickFinishCompanion() {
    if (session.pattern === 'curly' || session.pattern === 'coily' || session.style === 'curl') {
      return 'curl-cream';
    }
    if (session.hold === 'maximum' || (session.length === 'very-short' && session.finish === 'matte' && session.hold === 'strong')) {
      return 'grooming-clay';
    }
    if (session.length === 'very-short' || (session.finish === 'matte' && (session.length === 'short' || session.style === 'skin-fade' || session.style === 'clean-matte'))) {
      return 'matte-clay';
    }
    if (session.finish === 'shine' || session.style === 'side-part' || session.style === 'polished' || session.style === 'neat') {
      return 'defining-cream';
    }
    if (session.style === 'side-part-matte' || (session.finish === 'matte' && session.style === 'side-part')) {
      return 'grooming-clay';
    }
    if (session.finish === 'matte' || session.length === 'short' || session.length === 'very-short' || session.style === 'textured-crop' || session.style === 'skin-fade' || session.style === 'quiff') {
      return 'grooming-clay';
    }
    /* Default “wax” path — Texture Paste for natural / medium–long / flexible */
    return 'texture-paste';
  }

  /**
   * Soft two-product advice — barber tone, never a hard upsell.
   * Prep (spray) → suitable wax/clay/cream; finishers → light spray underneath.
   */
  function resolveCompanion(primaryHandle, opts) {
    const p = PRODUCT_KB[primaryHandle];
    if (!p) return null;
    const force = opts && opts.forcePairing;
    const wantLift = opts && opts.wantLift;

    if (primaryHandle === 'texture-spray') {
      const finish = pickFinishCompanion();
      if (finish === 'curl-cream') {
        /* Spray + curl is an odd primary pair — suggest curl cream as the damp-hair step instead */
        if (!productAvailable('curl-cream')) return null;
        return {
          handle: 'curl-cream',
          suggestion: 'Curl Cream with it?',
          html: `<p>For curls or waves, <strong>${pairLink('curl-cream')}</strong> on damp hair does the definition work — keep the spray for root lift on dry hair if you still want a bit more volume.</p>`
        };
      }
      if (!productAvailable(finish)) return null;
      const waxNote = finish === 'texture-paste' ? ' (the flexible, wax-like option in the range)' : '';
      return {
        handle: finish,
        suggestion: shortProductName(finish) + ' with it?',
        html: `<p>If you want a touch more shape after the spray, a small amount of <strong>${pairLink(finish)}</strong>${waxNote} is the usual chair combo — only if the spray alone isn’t enough hold.</p>`
      };
    }

    if (primaryHandle === 'curl-cream') {
      const finish = (session.length === 'short' || session.length === 'very-short' || session.finish === 'matte')
        ? 'grooming-clay'
        : 'texture-paste';
      if (!productAvailable(finish)) return null;
      return {
        handle: finish,
        suggestion: 'Tiny bit of ' + shortProductName(finish) + ' with it?',
        html: `<p>Once hair is fully dry, a <em>tiny</em> amount of <strong>${pairLink(finish)}</strong> can add separation — skip it if the cream alone feels right.</p>`
      };
    }

    if (p.role === 'finish' || p.pairing === 'texture-spray') {
      if (!productAvailable('texture-spray')) return null;
      const needsGrip = wantLift || force
        || session.thickness === 'fine'
        || session.style === 'volume'
        || session.hold === 'maximum'
        || (session.length === 'long' && (session.hold === 'strong' || session.hold === 'maximum'))
        || (session.wantWaxOrClay && (session.length === 'long' || session.length === 'medium'))
        || /lift|volume|flat|all day|stay in place/.test([session.thickness, session.style, session.hold].join(' '));
      if (needsGrip) {
        return {
          handle: 'texture-spray',
          suggestion: 'Texture Spray underneath?',
          html: `<p>For extra grip and hold, use a light mist of <strong>${pairLink('texture-spray')}</strong> first, then work this through — skip the spray if you already have plenty of body.</p>`
        };
      }
      return {
        handle: 'texture-spray',
        suggestion: 'Texture Spray with it?',
        html: `<p>A light mist of <strong>${pairLink('texture-spray')}</strong> underneath can add grip — useful, not essential, if you want a bit more hold or lift.</p>`
      };
    }

    return null;
  }

  function formatPairingSuggestion(primaryHandle, opts) {
    const companion = resolveCompanion(primaryHandle, opts || {});
    if (!companion) return { html: '', companion: null };
    return { html: companion.html, companion };
  }

  /* ========== Response format (Guide §10) ========== */
  function formatRecommendation(handle, opts) {
    const p = PRODUCT_KB[handle];
    if (!p) return `<p>Tell me a bit more about your hair and the look you want — I’ll recommend one product that fits.</p>`;

    session.lastHandle = handle;
    const price = productPrice(handle);
    const url = productUrl(handle);
    const whyBits = [];
    if (session.length) whyBits.push(session.length.replace('-', ' ') + ' hair');
    if (session.thickness) whyBits.push(session.thickness.replace('fine', 'finer') + ' density');
    if (session.pattern && session.pattern !== 'straight') whyBits.push(session.pattern + ' hair');
    if (session.finish === 'matte') whyBits.push('a matte / no-shine finish');
    if (session.finish === 'shine') whyBits.push('a little natural shine');
    if (session.finish === 'natural') whyBits.push('a natural finish');
    if (session.finish === 'wet' || session.style === 'wet-look') whyBits.push('a soft wet look');
    if (session.hold && session.hold !== 'flexible') whyBits.push(session.hold === 'maximum' ? 'all-day hold' : session.hold + ' hold');
    if (session.hold === 'flexible') whyBits.push('flexible, reworkable hold');
    if (session.style === 'volume') whyBits.push('lift and volume without a crunchy finish');
    else if (session.style === 'curl') whyBits.push('softer curl definition and less frizz');
    else if (session.style === 'wet-look') whyBits.push('light hold without going stiff');
    else if (session.style === 'side-part-matte') whyBits.push('a sharp side parting with a dry finish');
    else if (session.style) whyBits.push('a ' + session.style.replace(/-/g, ' ') + ' style');

    const why = whyBits.length
      ? `It suits ${whyBits.slice(0, 3).join(', ')}`
      : `It lines up with what you described`;

    const priceShow = price || p.priceLabel || p.priceFallback || '';
    let html = `<p>I'd put you on <strong><a href="${SHOP}${url}">${escapeHtml(p.name)}</a></strong>`;
    if (priceShow) html += ` (${escapeHtml(priceShow)})`;
    if (p.size) html += ` · ${escapeHtml(p.size)}`;
    if (p.badge) html += ` · ${escapeHtml(p.badge)}`;
    html += `. ${escapeHtml(why)} — ${escapeHtml(p.summary)}</p>`;
    html += `<p>${escapeHtml(p.hold)} hold with a ${escapeHtml(p.finish)} finish. ${escapeHtml(p.application.join(' '))}</p>`;

    const paired = opts.skipPairing ? { html: '' } : formatPairingSuggestion(handle, opts);
    if (paired.html) html += paired.html;

    html += `<p>${escapeHtml(p.tip)}</p>`;
    return html;
  }

  function recommendationSuggestions(handle, opts) {
    const companion = resolveCompanion(handle, opts || {});
    const chips = [];
    if (companion && companion.suggestion) chips.push(companion.suggestion);
    else chips.push('What pairs with it?');
    chips.push('How do I use it?');
    chips.push('How much product should I use?');
    if (handle === 'grooming-clay' || handle === 'matte-clay') {
      chips.push('Compare Grooming Clay and Matte Clay');
    } else if (handle === 'defining-cream' || handle === 'texture-paste') {
      chips.push('Cream or paste?');
    } else if (handle === 'texture-spray') {
      chips.push('What else is in the range?');
    } else {
      chips.push('Recommend another product');
    }
    return chips.slice(0, 4);
  }

  function nextQuestion() {
    session.questionsAsked += 1;
    if (!session.length) {
      return {
        html: `<p>I can narrow it down quickly. Is your hair <strong>short</strong>, <strong>medium</strong> or <strong>long</strong> — and do you prefer <strong>no shine</strong> or a <strong>little natural shine</strong>?</p>`,
        suggestions: ['Short + matte', 'Medium + natural', 'Long + natural movement', 'Curly / wavy'],
        voicePass: true
      };
    }
    if (!session.finish && !session.hold && !session.pattern) {
      return {
        html: `<p>Got it — ${escapeHtml(session.length.replace('-', ' '))} hair. Do you want <strong>no shine (matte)</strong>, a <strong>natural finish</strong>, or a <strong>little shine</strong>? And is hold more <strong>flexible</strong> or <strong>strong</strong>?</p>`,
        suggestions: ['Matte + strong hold', 'Natural + flexible', 'A little shine + neat', 'Volume / lift'],
        voicePass: true
      };
    }
    if (!session.pattern && !session.style) {
      return {
        html: `<p>One more — is your hair <strong>straight</strong>, <strong>wavy</strong> or <strong>curly</strong>, and what’s the style goal (crop, side part, natural movement, curls…)?</p>`,
        suggestions: ['Straight textured crop', 'Polished side part', 'Natural movement', 'Curly + frizz control'],
        voicePass: true
      };
    }
    return {
      html: `<p>Tell me the finish you want (matte / natural / a little shine) and I’ll recommend one product.</p>`,
      suggestions: ['Matte finish', 'Natural movement', 'A little shine', 'Volume without crunch'],
      voicePass: true
    };
  }

  /* ========== FAQ knowledge base (phrase / keyword scored matching) ========== */
  /* Opening / service — clear and professional */
  const suggestionsHelp = ['About the brand', 'How much is UK shipping?', 'Recommend a product', 'Are products vegan?'];
  /* Soft pivot into a consult after education or range gaps */
  const suggestionsConsult = ['Recommend a product', 'Short + matte', 'Natural movement', 'Curly + frizz control'];
  const suggestionsProduct = ['How do I use it?', 'What pairs with it?', 'Recommend for my hair', 'How much is UK shipping?'];
  const suggestionsPolicies = ['Terms & conditions', 'Privacy policy', 'Refund policy', 'How much is UK shipping?'];

  /**
   * Deep knowledge corpus — scored retrieval for education, adjacent topics,
   * and slightly off-scope questions (honest pivot, never invent products).
   */
  const KNOWLEDGE = [
    {
      id: 'matte-meaning',
      phrases: ['what is matte', 'what does matte mean', 'matte finish', 'no shine', 'dry finish', 'not shiny'],
      keywords: ['matte', 'shine', 'glossy', 'dull', 'dry'],
      html: () => `<p><strong>Matte</strong> means little to no shine — a natural, dry look rather than glossy or wet.</p>
                   <p>For that finish in the 4U range: <strong>Matte Clay</strong> (true matte, medium hold) or <strong>Grooming Clay</strong> (strong hold, matte / low shine).</p>`
    },
    {
      id: 'hold-meaning',
      phrases: ['what is hold', 'what does hold mean', 'strong hold', 'flexible hold', 'maximum hold', 'how strong'],
      keywords: ['hold', 'grip', 'stiff', 'flexible', 'maximum', 'strong'],
      html: () => `<p><strong>Hold</strong> is how firmly a product keeps your style in place.</p>
                   <p>• <strong>Soft / flexible</strong> — Texture Paste (movement)<br>
                   • <strong>Medium</strong> — Matte Clay, Curl Cream<br>
                   • <strong>Strong / Firm</strong> — Grooming Clay, Defining Cream<br>
                   • <strong>High 2-in-1</strong> — Texture Spray (style + finish)</p>
                   <p>Tell me your length and finish and I’ll match the hold.</p>`
    },
    {
      id: 'water-soluble',
      phrases: ['water soluble', 'water-soluble', 'washes out easily', 'greasy buildup', 'build up'],
      keywords: ['soluble', 'water', 'buildup', 'greasy'],
      html: () => `<p>4U stylers are built as <strong>water-soluble</strong> formulas — they wash out with standard shampoo when used as directed, without that greasy buildup feeling.</p>
                   <p>Start with a small amount and you’ll get a clean reset in the shower.</p>`
    },
    {
      id: 'ethical',
      phrases: [
        'how ethical', 'are they ethical', 'ethical products', 'ethics', 'ethically',
        'environmentally', 'eco friendly', 'good for the planet', 'animal testing',
        'tested on animals', 'cruelty free', 'responsibly sourced'
      ],
      keywords: ['ethical', 'ethics', 'ethically', 'cruelty', 'vegan', 'sustainable', 'environment', 'eco', 'animals'],
      html: () => {
        const claims = BRAND_FACTS.claims.map((c) => {
          const detail = BRAND_FACTS.claimDetails[c];
          return detail ? `• <strong>${escapeHtml(c)}</strong> — ${escapeHtml(detail)}` : `• ${escapeHtml(c)}`;
        }).join('<br>');
        return `<p>Ethics sit at the core of how 4U is made:</p><p>${claims}</p>
                <p>We’re a UK barber-built brand — no animal testing, vegan formulation, and responsibly sourced ingredients where specified. For a full INCI list on a specific product, check the product page or email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`;
      }
    },
    {
      id: 'sku-size',
      phrases: ['what size', 'how big', 'ml', '100ml', '250ml', 'sku', 'product code'],
      keywords: ['size', 'ml', 'sku', 'grams', 'jar', 'bottle'],
      html: () => `<p>${escapeHtml(BRAND_FACTS.sizes)}</p>
                   <p>• Clays, paste, Defining Cream, Curl Cream — <strong>100ml</strong><br>
                   • Travel minis — <strong>15ml</strong> (Texture Paste, Grooming Clay, Matte Clay, Defining Cream)<br>
                   • Texture Spray — <strong>250ml</strong> (SKU 4U-TS-250) · travel <strong>50ml</strong> (SKU 4U-TS-050)<br>
                   • Texture Paste SKU 4U-TP-100 · Grooming Clay 4U-GC-100 · Matte Clay 4U-MC-100</p>
                   <p>Live price is on each product page (and free UK shipping over £${FREE}).</p>`
    },
    {
      id: 'best-seller',
      phrases: ['best seller', 'bestseller', 'most popular', 'best product', 'what sells most'],
      keywords: ['bestseller', 'popular', 'best'],
      html: () => `<p><strong>Texture Paste</strong> is marked <em>Best Seller</em> on the site — looser natural movement, and the wax-like option people ask for most.</p>
                   <p>That said, the “best” product is the one that matches your length and finish. Tell me those and I’ll pick properly.</p>`
    },
    {
      id: 'trustpilot',
      phrases: ['trustpilot', 'reviews', 'ratings', '5 star', 'five star', 'testimonials'],
      keywords: ['trustpilot', 'reviews', 'rating', 'stars', 'testimonial'],
      html: () => {
        const tp = SOCIAL.trustpilot || 'https://uk.trustpilot.com/review/4uhairproducts.com';
        const t = BRAND_FACTS.testimonial;
        return `<p>We’re on Trustpilot (${escapeHtml(BRAND_FACTS.trustpilotLabel)}) — <a href="${tp}" target="_blank" rel="noopener">read reviews</a>.</p>
                <p>Customer note on Texture Paste — ${escapeHtml(t.author)}: “${escapeHtml(t.quote)}”</p>`;
      }
    },
    {
      id: 'product-grooming',
      phrases: ['tell me about grooming clay', 'grooming clay info', 'grooming clay details'],
      keywords: ['grooming'],
      html: () => answerProductCard('grooming-clay').html
    },
    {
      id: 'product-matte',
      phrases: ['tell me about matte clay', 'matte clay info', 'matte clay details'],
      keywords: [],
      html: () => answerProductCard('matte-clay').html
    },
    {
      id: 'product-paste',
      phrases: ['tell me about texture paste', 'texture paste info', 'about the paste', 'about the wax'],
      keywords: [],
      html: () => answerProductCard('texture-paste').html
    },
    {
      id: 'product-spray',
      phrases: ['tell me about texture spray', 'texture spray info', 'about the spray', '2 in 1 spray'],
      keywords: [],
      html: () => answerProductCard('texture-spray').html
    },
    {
      id: 'product-cream',
      phrases: ['tell me about defining cream', 'defining cream info', 'about the cream'],
      keywords: [],
      html: () => answerProductCard('defining-cream').html
    },
    {
      id: 'product-curl',
      phrases: ['tell me about curl cream', 'curl cream info', 'about curl cream'],
      keywords: [],
      html: () => answerProductCard('curl-cream').html
    },
    {
      id: 'texture-combo',
      phrases: ['texture combo', 'spray and paste', 'spray and clay', 'layer spray'],
      keywords: ['combo'],
      html: () => `<p>A classic 4U <strong>texture combo</strong>: mist <strong>Texture Spray</strong> for lift/grip, then shape with <strong>Texture Paste</strong> (natural movement) or a clay (more structure).</p>
                   <p>I only suggest both when it improves the result — say your length and finish and I’ll name the pair.</p>`
    },
    {
      id: 'clay-vs-paste',
      phrases: ['clay or paste', 'clay vs paste', 'difference clay paste', 'wax or clay', 'paste or clay'],
      keywords: ['clay', 'paste', 'wax', 'difference'],
      html: () => `<p><strong>Clays</strong> (Grooming / Matte) — stronger set, matte or ultra-dry, best for shorter structured styles.</p>
                   <p><strong>Texture Paste</strong> — the wax-like option: flexible, natural, reworkable, better for medium–long movement.</p>
                   <p>Short + matte → clay. Natural movement → paste.</p>`
    },
    {
      id: 'cream-vs-paste',
      phrases: ['cream or paste', 'cream vs paste', 'defining or texture', 'shine or natural'],
      keywords: ['cream', 'paste', 'defining', 'shine'],
      html: () => `<p><strong>Defining Cream</strong> — neater control with a little natural shine (side parts, polished looks).</p>
                   <p><strong>Texture Paste</strong> — softer, more relaxed, less shine, easy to reshape during the day.</p>`
    },
    {
      id: 'spray-vs-hairspray',
      phrases: ['is it hairspray', 'like hairspray', 'crunchy spray', 'finishing spray', '2 in 1', 'not crunchy'],
      keywords: ['hairspray', 'crunchy', 'crunch', 'stiff', 'aerosol'],
      html: () => `<p><strong>4U Texture Spray</strong> (250ml) is the ultimate <strong>2-in-1</strong> — style your hair and hold the finished look. Soft & airy, high volume/texture, great for all hair types.</p>
                   <p>Use on towel-dried hair to style, or ~25cm away on dry hair as a finisher. It stays more flexible than a classic crunchy hairspray, and pairs brilliantly with paste or clay.</p>`
    },
    {
      id: 'wash-out',
      phrases: [
        'how to wash out', 'how do i wash', 'wash it out', 'wash out', 'does it wash out',
        'hard to wash', 'residue', 'build up', 'buildup', 'shampoo out', 'get it out'
      ],
      keywords: ['wash', 'residue', 'buildup', 'build', 'shampoo', 'rinse', 'out'],
      html: () => `<p>All 4U stylers are designed to wash out with a normal shampoo — start with a modest amount so you don’t over-apply.</p>
                   <p>If hair ever feels coated, a thorough wash (and going lighter next time) usually sorts it. We’re paraben-free and sulphate-free across the range.</p>`
    },
    {
      id: 'rework',
      phrases: ['rework', 'restyle', 'reshape', 'during the day', 'run hands through', 'touch up'],
      keywords: ['rework', 'restyle', 'reshape', 'touch'],
      html: () => `<p>For styles you want to reshape during the day, <strong>Texture Paste</strong> and <strong>Texture Spray</strong> are the most reworkable.</p>
                   <p>Clays set firmer — still usable, but less “soft reset” than paste. Warm a tiny bit more between the palms if you need a touch-up.</p>`
    },
    {
      id: 'humidity',
      phrases: ['humidity', 'humid', 'rain', 'sweat', 'gym', 'hot weather', 'summer', 'hold up'],
      keywords: ['humidity', 'humid', 'rain', 'sweat', 'gym', 'weather', 'summer'],
      html: () => `<p>In humidity or at the gym, stronger hold and less soft product usually lasts better — <strong>Grooming Clay</strong> or <strong>Matte Clay</strong> for short hair; don’t overload mid-lengths if you want movement.</p>
                   <p>Texture Spray can help with grip first. No product is weatherproof forever — a light restyle after is normal.</p>`
    },
    {
      id: 'fine-hair',
      phrases: ['fine hair', 'thin hair', 'flat hair', 'no volume', 'weigh down', 'weighs down'],
      keywords: ['fine', 'thin', 'flat', 'volume', 'weigh'],
      html: () => `<p>Fine or flat hair usually wants <strong>less product</strong> and more lift: start with <strong>Texture Spray</strong> at the roots, then a very small amount of clay or paste only where you need shape.</p>
                   <p>Heavy hands are what weigh fine hair down — build gradually.</p>`
    },
    {
      id: 'thick-hair',
      phrases: ['thick hair', 'coarse hair', 'hard to control', 'lots of hair', 'dense hair'],
      keywords: ['thick', 'coarse', 'dense', 'control'],
      html: () => `<p>Thick hair can take a bit more product and often likes stronger hold — <strong>Grooming Clay</strong> for short–medium matte texture, or <strong>Defining Cream</strong> if you want neater control with light shine.</p>
                   <p>Warm it well and distribute from the back forward so you’re not dumping it all on top.</p>`
    },
    {
      id: 'curly-care',
      phrases: ['curly hair', 'wavy hair', 'frizz', 'define curls', 'diffuser', 'air dry curls'],
      keywords: ['curl', 'curly', 'wavy', 'frizz', 'diffuse', 'coily'],
      html: () => `<p>For waves and curls, <strong>Curl Cream</strong> on <em>damp</em> hair is the go-to — scrunch, then air-dry or diffuse. Avoid brushing once the pattern is forming.</p>
                   <p>That’s the product to start with — not Defining Cream (that’s for neat polished styles). Any clay/paste only after fully dry, and only a tiny amount for separation.</p>`
    },
    {
      id: 'wet-vs-dry',
      phrases: ['wet hair', 'damp hair', 'dry hair', 'towel dried', 'apply on wet', 'on dry'],
      keywords: ['wet', 'damp', 'dry', 'towel'],
      html: () => `<p><strong>Curl Cream</strong> — damp hair.<br>
                   <strong>Clays, paste, Defining Cream</strong> — dry or almost-dry / towel-dried.<br>
                   <strong>Texture Spray</strong> — dry hair for finish, or as prep before you style.</p>
                   <p>Applying heavy clay on soaking-wet hair usually dilutes the hold.</p>`
    },
    {
      id: 'how-much',
      phrases: ['how much should i use', 'pea size', 'too much product', 'over apply', 'start small'],
      keywords: ['amount', 'pea', 'much', 'overdo'],
      html: () => `<p>Start small — often a pea-sized amount for short hair; a little more for thick or longer hair. Warm it fully between the palms first.</p>
                   <p>You can always add more. Too much at once is what makes hair look heavy or greasy.</p>`
    },
    {
      id: 'greasy',
      phrases: ['looks greasy', 'looks wet', 'too shiny', 'oily look', 'helmet hair'],
      keywords: ['greasy', 'oily', 'wet', 'helmet', 'heavy'],
      html: () => `<p>That usually means too much product, or the wrong finish for the look you want.</p>
                   <p>Wash out, go lighter next time, and if you want zero shine switch toward <strong>Grooming Clay</strong> or <strong>Matte Clay</strong> rather than cream.</p>`
    },
    {
      id: 'beginner',
      phrases: ['first time', 'beginner', 'never used', 'simple routine', 'easy product', 'one product'],
      keywords: ['beginner', 'first', 'simple', 'easy', 'starter'],
      html: () => `<p>Keep it simple: one hero product that matches your length + finish.</p>
                   <p>Common starters — short matte: <strong>Grooming Clay</strong>. Natural medium hair: <strong>Texture Paste</strong>. Flat hair needing lift: <strong>Texture Spray</strong>. Curls: <strong>Curl Cream</strong>.</p>
                   <p>Tell me your length and whether you want matte or natural and I’ll pick one.</p>`
    },
    {
      id: 'beard',
      phrases: ['beard', 'moustache', 'mustache', 'facial hair', 'beard oil', 'beard balm'],
      keywords: ['beard', 'moustache', 'mustache', 'facial'],
      html: () => `<p>4U is focused on <strong>hair styling</strong> rather than dedicated beard oils or balms.</p>
                   <p>A tiny amount of paste or cream can tame longer facial hair in a pinch, but for true beard care I’d look at a specialist balm — and I can still help you pick a 4U styler for the hair on your head.</p>`
    },
    {
      id: 'haircut-advice',
      phrases: ['what haircut', 'what fade', 'should i get a fade', 'recommend a haircut', 'barber shop', 'how should i cut'],
      keywords: ['haircut', 'fade', 'trim', 'barber', 'cut'],
      html: () => `<p>I won’t prescribe a specific haircut from here — that’s a chair conversation with your barber (face shape, growth patterns, lifestyle).</p>
                   <p>Once you’ve got the cut, tell me the length and finish you want and I’ll match the 4U product so it lands the way you pictured.</p>`
    },
    {
      id: 'women-men',
      phrases: ['for men', 'for women', 'unisex', 'can girls use', 'can women use', 'mens products'],
      keywords: ['men', 'women', 'girls', 'unisex', 'ladies', 'male', 'female'],
      html: () => `<p>4U is built around <strong>hair type and finish</strong>, not gender. Clays, paste, cream and spray all work across short and longer styles.</p>
                   <p>Tell me length + the look (matte, natural, curls, lift) and I’ll recommend from the range.</p>`
    },
    {
      id: 'age',
      phrases: ['for teens', 'for kids', 'how old', 'teenager', 'school'],
      keywords: ['teen', 'kids', 'child', 'school', 'age'],
      html: () => `<p>Products are made for general styling use — always patch-check if someone has a sensitive scalp, and keep amounts small for finer younger hair.</p>
                   <p>I can’t give medical advice; for sensitive skin concerns check the label and email <a href="mailto:${EMAIL}">${EMAIL}</a> if you need ingredient detail.</p>`
    },
    {
      id: 'colour-treated',
      phrases: ['coloured hair', 'colored hair', 'bleached', 'dyed', 'highlights', 'keratin', 'treated hair'],
      keywords: ['colour', 'color', 'bleach', 'dyed', 'highlight', 'keratin', 'treated'],
      html: () => `<p>4U stylers are paraben-free and sulphate-free. They’re made for everyday styling; they’re not a colour treatment.</p>
                   <p>If hair is very fragile from bleaching, use less product and avoid overworking it. For colouring advice, speak to your colourist.</p>`
    },
    {
      id: 'samples',
      phrases: ['sample', 'tester', 'try before', 'travel size', 'mini size', 'sachet', '15ml'],
      keywords: ['sample', 'tester', 'travel', 'mini', 'sachet', '15ml'],
      html: () => `<p>We don’t offer separate sample sachets, but we do have <strong>15ml travel minis</strong> of Texture Paste, Grooming Clay, Matte Clay and Defining Cream — same formulas as the 100ml jars.</p>
                   <p>Ask for a travel size of the finish you want, or tell me your hair length and finish and I’ll pick one.</p>`
    },
    {
      id: 'bundle',
      phrases: ['bundle', 'duo', 'set', 'deal', 'multi buy', 'buy two', 'discount two'],
      keywords: ['bundle', 'duo', 'set', 'deal', 'multi'],
      html: () => `<p>There’s no fixed bundle SKU right now — just add the products you want to the cart. Free UK shipping over £${FREE} is the main saving.</p>
                   <p>If you want a smart two-product combo (e.g. spray + paste), say what look you’re after and I’ll pair them properly.</p>`
    },
    {
      id: 'stock',
      phrases: ['in stock', 'out of stock', 'when back', 'restock', 'available'],
      keywords: ['stock', 'restock', 'available', 'sold'],
      html: () => `<p>Availability is shown on each product page. If something’s missing, email <a href="mailto:${EMAIL}">${EMAIL}</a> and the team can advise on restocks.</p>
                   <p>Meanwhile I can suggest the closest alternative in the range for your style.</p>`
    },
    {
      id: 'competitor',
      phrases: ['better than', 'vs uppercut', 'vs american crew', 'like hanz', 'dupe', 'alternative to'],
      keywords: ['vs', 'versus', 'dupe', 'alternative', 'better', 'compared'],
      html: () => `<p>I won’t rubbish other brands — different formulas suit different people. 4U is barber-built in the UK: clays, paste, cream, texture spray and curl cream with clear hold/finish roles.</p>
                   <p>Tell me the finish you want (matte, natural, shine, curls) and I’ll map it to the closest 4U product.</p>`
    },
    {
      id: 'smell-scent',
      phrases: ['what does it smell', 'fragrance', 'scent', 'perfume', 'strong smell', 'unscented'],
      keywords: ['smell', 'scent', 'fragrance', 'perfume', 'odour', 'odor'],
      html: () => `<p>Scent can vary slightly by product and batch — check the product page for the latest notes. Nothing in the range is positioned as a heavy cologne.</p>
                   <p>If you have a fragrance sensitivity, patch-test and email <a href="mailto:${EMAIL}">${EMAIL}</a> for ingredient detail before you commit.</p>`
    },
    {
      id: 'expiry',
      phrases: ['expiry', 'expire', 'shelf life', 'how long last', 'use by', 'best before'],
      keywords: ['expiry', 'expire', 'shelf', 'lasts', 'pao'],
      html: () => `<p>Check the jar/tube for the period-after-opening symbol and any best-before guidance on the pack.</p>
                   <p>Store cool and dry with the lid on. If a product ever looks or smells off, don’t use it — email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
    },
    {
      id: 'made-where',
      phrases: ['where made', 'where manufactured', 'british', 'uk brand', 'made in england'],
      keywords: ['made', 'manufactured', 'uk', 'british', 'england'],
      html: () => `<p>4U products are <strong>Made in the UK</strong>, built from barber-chair experience by founder Bradley Connellan.</p>
                   <p><a href="${SHOP}${BRAND.aboutUrl || '/#founder'}">Read the brand story →</a></p>`
    },
    {
      id: 'barber-approved',
      phrases: ['barber approved', 'professional', 'salon quality', 'used by barbers', 'trade'],
      keywords: ['barber', 'professional', 'salon', 'trade', 'chair'],
      html: () => `<p>That’s the point of the brand — Bradley built 4U from real chair work, not trend marketing. The range is meant to be clear: pick by length, hold and finish.</p>
                   <p>Wholesale / stockist enquiries: <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
    },
    {
      id: 'skin-scalp',
      phrases: ['sensitive scalp', 'itchy scalp', 'irritate', 'skin safe', 'on skin'],
      keywords: ['scalp', 'itchy', 'irritat', 'sensitive', 'skin'],
      html: () => `<p>Formulas are paraben-free and sulphate-free, but everyone’s skin is different — I can’t give medical advice.</p>
                   <p>Patch-test if you’re sensitive, read the ingredient list on the product page, and speak to a professional if you have a scalp condition. Product questions: <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
    },
    {
      id: 'pomade-gel-redirect',
      phrases: ['want pomade', 'want gel', 'slick back gel', 'high shine gel', 'do you sell pomade'],
      keywords: ['pomade', 'gel', 'slick'],
      html: () => `<p>We don’t sell gel or classic pomade. Closest routes in the range:</p>
                   <p>• Soft wet look / light hold → <strong>Curl Cream</strong> on damp hair<br>
                   • Neater with a little shine → <strong>Defining Cream</strong><br>
                   • Flexible natural / “wax” feel → <strong>Texture Paste</strong><br>
                   • Matte texture, not wet look → <strong>Grooming Clay</strong></p>
                   <p>What length and finish do you want?</p>`
    },
    {
      id: 'wet-look-guide',
      phrases: ['wet look', 'wet-look', 'soft wet look', 'want a wet look', 'damp shine look'],
      keywords: ['wet'],
      html: () => `<p>For a soft <strong>wet look</strong> with light hold, <strong>Curl Cream</strong> is the pick — small amount through damp hair, then air-dry for shine and definition without going stiff or crunchy.</p>
                   <p>If you want a neater, stronger polished shine instead, ask about <strong>Defining Cream</strong>.</p>`
    },
    {
      id: 'matte-clay-who',
      phrases: [
        'what hair type matte clay', 'who should use matte clay', 'matte clay for',
        'when to use matte clay', 'should i use matte clay', 'best hair for matte clay',
        'what hair type should i use matte clay', 'matte clay hair type'
      ],
      keywords: ['matte clay', 'hair type'],
      html: () => `<p><strong>4U Matte Clay</strong> is best for <strong>short, thick or stubborn hair</strong> that needs a very dry, matte finish.</p>
                   <p>It works especially well for textured crops, choppy styles, skin fades and short messy looks. It’s less suited to longer hair — the hold can feel too heavy and dry.</p>
                   <p>For longer hair with no shine, <strong>Texture Paste</strong> is usually the better flexible option.</p>`
    },
    {
      id: 'office-work',
      phrases: ['office', 'work hair', 'professional look', 'job interview', 'smart'],
      keywords: ['office', 'work', 'professional', 'interview', 'smart'],
      html: () => `<p>For a clean professional look, <strong>Defining Cream</strong> is usually the pick — controlled, light natural shine, easy with a comb.</p>
                   <p>If you want smart but matte, <strong>Grooming Clay</strong> with a controlled shape works well too.</p>`
    },
    {
      id: 'wedding-event',
      phrases: ['wedding', 'event', 'photos', 'all day hold', 'special occasion'],
      keywords: ['wedding', 'event', 'photo', 'occasion', 'party'],
      html: () => `<p>For all-day events, match hold to your cut: short structured → <strong>Grooming Clay</strong> or <strong>Matte Clay</strong>; neat with light shine → <strong>Defining Cream</strong>.</p>
                   <p>Do a trial run before the day so you know how much product you need under pressure (and humidity).</p>`
    },
    {
      id: 'travel',
      phrases: ['airport', 'hand luggage', 'cabin bag', 'travel with', 'flying', '15ml'],
      keywords: ['airport', 'travel', 'flight', 'luggage', 'cabin', 'tsa', '15ml'],
      html: () => `<p>Our <strong>15ml travel minis</strong> are sized for cabin bags: Texture Paste, Grooming Clay, Matte Clay and Defining Cream — same formulas as the 100ml jars. Texture Spray also has a <strong>50ml</strong> travel bottle.</p>
                   <p>Still check your airline’s liquid rules before you fly. Tell me which finish you want (matte, natural, shine) and I’ll point you to the right mini.</p>`
    },
    {
      id: 'price-value',
      phrases: ['worth it', 'good value', 'expensive', 'why cost', 'cheap'],
      keywords: ['worth', 'value', 'expensive', 'cheap', 'price'],
      html: () => `<p>Pricing sits on each product page. You’re paying for UK-made, barber-led formulas with a clear job (hold + finish) rather than a huge confusing range.</p>
                   <p>A jar goes further if you start small. Free UK shipping over £${FREE}.</p>`
    },
    {
      id: 'account-login',
      phrases: ['create account', 'login', 'my account', 'password', 'order history'],
      keywords: ['account', 'login', 'password', 'history'],
      html: () => `<p>Checkout can run as a guest or with a Shopify account, depending on how you pay.</p>
                   <p>For login or order-history issues, email <a href="mailto:${EMAIL}">${EMAIL}</a> with the order email address.</p>`
    },
    {
      id: 'offtopic-lifestyle',
      phrases: ['whats the weather', 'tell me a joke', 'who are you', 'are you ai', 'are you real', 'chatgpt'],
      keywords: ['joke', 'weather', 'ai', 'robot', 'chatgpt', 'human'],
      html: () => `<p>I’m the <strong>4U Virtual Barber</strong> — a guide for the 4U range, styling advice, shipping and brand questions.</p>
                   <p>I stay in that lane on purpose. What do you want help with — product pick, how to use something, or an order/shipping question?</p>`
    },
    {
      id: 'offtopic-other',
      phrases: ['recipe', 'football', 'crypto', 'politics', 'homework'],
      keywords: ['recipe', 'football', 'crypto', 'bitcoin', 'politics', 'homework'],
      html: () => `<p>That’s outside what I cover — I’m here for 4U hair products and styling.</p>
                   <p>Ask me about hold, finish, which product fits your hair, shipping, or the brand.</p>`
    }
  ];

  const STOP_WORDS = {
    a: 1, an: 1, the: 1, and: 1, or: 1, to: 1, for: 1, of: 1, in: 1, on: 1, is: 1, it: 1, my: 1,
    me: 1, i: 1, you: 1, your: 1, do: 1, does: 1, did: 1, can: 1, could: 1, would: 1, should: 1,
    what: 1, which: 1, how: 1, when: 1, where: 1, why: 1, with: 1, from: 1, about: 1, please: 1
  };

  function tokenize(q) {
    return normalize(q).split(' ').filter((t) => t.length > 2 && !STOP_WORDS[t]);
  }

  function isEducationOrAdjacentQuery(q) {
    if (/^how about\b/.test(q)) return false;
    return /^(what|whats|what's|how|why|can|does|is|are|do|will|should|tell me|explain)\b/.test(q)
      || /what (is|are|does|do)|how (do|does|to|much|long|often)|difference|mean|vs\b|versus|can i|is it|do you/.test(q);
  }

  function scoreKnowledgeEntry(q, tokens, entry) {
    let score = scorePhrases(q, entry.phrases || []);
    score += scoreKeywords(q, entry.keywords || []);
    tokens.forEach((t) => {
      (entry.keywords || []).forEach((kw) => {
        const k = normalize(kw);
        if (k.length > 3 && (k.indexOf(t) === 0 || t.indexOf(k) === 0)) score += 3;
      });
    });
    return score;
  }

  function retrieveKnowledge(query) {
    const q = normalize(query);
    const tokens = tokenize(query);
    let best = null;
    let bestScore = 0;
    KNOWLEDGE.forEach((entry) => {
      const score = scoreKnowledgeEntry(q, tokens, entry);
      if (score > bestScore) {
        bestScore = score;
        best = entry;
      }
    });
    /* Threshold: need a real signal; education questions can score a bit lower */
    const min = isEducationOrAdjacentQuery(q) ? 10 : 14;
    if (!best || bestScore < min) return null;
    return { entry: best, score: bestScore };
  }

  function searchProductFields(query) {
    const q = normalize(query);
    const tokens = tokenize(query);
    if (!tokens.length) return null;
    let best = null;
    let bestScore = 0;
    Object.keys(PRODUCT_KB).forEach((handle) => {
      const p = PRODUCT_KB[handle];
      if (!p || p.aliasOf) return;
      const blob = normalize([
        p.name, p.summary, p.tip, p.hold, p.finish, p.finishPlain,
        ...(p.recommendWhen || []), ...(p.avoidWhen || []), ...(p.application || []), ...(p.aliases || [])
      ].join(' '));
      let score = 0;
      tokens.forEach((t) => {
        if (blob.indexOf(t) !== -1) score += t.length > 4 ? 5 : 3;
      });
      [p.name, ...(p.aliases || [])].forEach((a) => {
        const n = normalize(a);
        if (q.indexOf(n) !== -1 && n.length > 3) score += 15;
      });
      if (score > bestScore) {
        bestScore = score;
        best = handle;
      }
    });
    if (!best || bestScore < 12) return null;
    return { handle: best, score: bestScore };
  }

  function answerFromKnowledge(query) {
    const hit = retrieveKnowledge(query);
    if (!hit) return null;
    const html = typeof hit.entry.html === 'function' ? hit.entry.html() : hit.entry.html;
    const result = {
      html,
      suggestions: suggestionsConsult.slice(),
      voicePass: true,
      lockDraft: true
    };
    if (hit.entry.id === 'curly-care') result.primaryHandle = 'curl-cream';
    return result;
  }

  function findKbByQuery(query) {
    const q = normalize(query);
    let best = null;
    let bestScore = 0;
    Object.keys(PRODUCT_KB).forEach((handle) => {
      const p = PRODUCT_KB[handle];
      if (!p || p.aliasOf || p.available === false) return;
      let score = 0;
      [p.name, ...(p.aliases || [])].forEach((a) => {
        const n = normalize(a);
        if (!n || n.length < 4) return;
        /* Require word boundaries so "curl" does not match inside "curly" */
        const re = new RegExp('(?:^|\\s)' + n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:\\s|$)');
        if (q === n) score = Math.max(score, 100);
        else if (re.test(q)) score = Math.max(score, 40 + Math.min(20, n.length));
      });
      if (score > bestScore) {
        bestScore = score;
        best = handle;
      }
    });
    return bestScore >= 40 ? best : null;
  }

  function answerCompare(query) {
    const q = normalize(query);
    if (/grooming/.test(q) && /matte/.test(q)) {
      return `<p><strong>Grooming Clay</strong> gives strong matte texture with more versatility for short to medium styles.<br>
              <strong>Matte Clay</strong> is the driest, strongest and most structured option — best for very short, ultra-matte looks.</p>`;
    }
    if (/paste/.test(q) && /cream|defining/.test(q)) {
      return `<p><strong>Texture Paste</strong> is more relaxed, natural and reworkable.<br>
              <strong>Defining Cream</strong> is neater, more controlled, with a touch more shine.</p>`;
    }
    if (/paste/.test(q) && /clay/.test(q)) {
      return `<p><strong>Texture Paste</strong> — flexible hold, natural movement, reworkable.<br>
              <strong>Clays</strong> — stronger set, matte or low shine, more structure for shorter styles.</p>`;
    }
    return `<p>Quick guide (live 4U range):<br>
      • <strong>Grooming Clay</strong> (100ml) — strong/firm hold, matte / low shine<br>
      • <strong>Matte Clay</strong> (100ml) — medium hold, true matte<br>
      • <strong>Texture Paste</strong> (100ml, Best Seller) — soft hold, natural movement (wax-like)<br>
      • <strong>Defining Cream</strong> (100ml) — strong hold, light shine<br>
      • <strong>Texture Spray</strong> (250ml) — 2-in-1 style + finish, soft & airy<br>
      • <strong>Curl Cream</strong> (100ml, New) — hydrated curls, wet look or matte break-up</p>
      <p>Tell me your length and finish and I’ll pick one.</p>`;
  }

  function answerShipping(query) {
    const q = normalize(query);
    if (/international|abroad|worldwide|europe|usa|us\b|overseas|outside (the )?uk|ship to/.test(q)) {
      return `<p>We currently focus on <strong>UK</strong> orders for the fastest delivery, and we’re looking to expand internationally soon.</p><p>UK shipping is ${SHIP}. Free over £${FREE}.</p><p>For anything order-specific, email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`;
    }
    if (/scotland|wales|northern ireland|ni\b/.test(q)) {
      return `<p>Yes — UK-wide, including Scotland, Wales and Northern Ireland. Shipping is ${SHIP}, or free over £${FREE}.</p>`;
    }
    if (/free|over\s*30/.test(q)) {
      return `<p>Free UK shipping on orders over <strong>£${FREE}</strong>. Below that, shipping is ${SHIP}.</p>`;
    }
    if (/how long|when (will|do)|arrival|arrive|dispatch|working day/.test(q)) {
      return `<p>UK orders are usually dispatched quickly after purchase. Exact timing depends on your location and carrier — for a specific order, email <a href="mailto:${EMAIL}">${EMAIL}</a> with your order number.</p><p>Shipping is ${SHIP}, or free over £${FREE}.</p>`;
    }
    const shipPol = policyLink(['shipping', 'delivery'], 'Shipping policy');
    return `<p>UK shipping is <strong>${SHIP}</strong>. Free on orders over <strong>£${FREE}</strong>.</p>
            ${shipPol ? `<p>More detail: ${shipPol}.</p>` : ''}
            <p>For tracking or a specific order, email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`;
  }

  function answerFounder() {
    const name = BRAND.founder || 'Bradley Connellan';
    const story = BRAND.story || BRAND_FACTS.founderBio;
    const bio = BRAND.founderBio || BRAND_FACTS.founderBio;
    return lockReply({
      html: `<p><strong>${escapeHtml(name)}</strong> runs ${escapeHtml(BRAND.name || '4U Hair Products')} — ${escapeHtml(BRAND_FACTS.founderTitle)}.</p>
             <p>${escapeHtml(bio || story)}</p>
             <p>${escapeHtml(BRAND_FACTS.positioning)} ${escapeHtml(BRAND_FACTS.rangeLine)}</p>
             <p><a href="${SHOP}${BRAND.aboutUrl || '/#founder'}">Meet the founder →</a></p>`,
      suggestions: ['Are products vegan?', 'Recommend a product', 'How much is UK shipping?']
    });
  }

  function productFactsLine(handle) {
    const p = PRODUCT_KB[handle];
    if (!p) return '';
    const price = productPrice(handle) || p.priceLabel || p.priceFallback || '';
    const bits = [];
    if (p.size) bits.push(p.size);
    if (price) bits.push(price);
    if (p.badge) bits.push(p.badge);
    if (p.sku) bits.push('SKU ' + p.sku);
    return bits.join(' · ');
  }

  /** Drop ingredient dumps / overlong PDP copy from chat replies */
  function trimChatCopy(text) {
    let t = String(text || '').trim();
    if (!t) return '';
    t = t.replace(/\b(ingredients?|inci)\s*[:\-–].*$/i, '').trim();
    if (t.length > 220) t = t.slice(0, 217).replace(/\s+\S*$/, '') + '…';
    return t;
  }

  function answerProductCard(handle) {
    const p = PRODUCT_KB[handle];
    if (!p) return null;
    if (p.hiddenUnless4her && !cfg.show4her && !(cfg.products || []).some((x) => x && x.handle === handle)) {
      return {
        html: `<p>4HER is our dedicated line (starting with a 2-in-1 texture spray). The core 4U range is always available — tell me your length and finish and I’ll recommend from that.</p>`,
        suggestions: suggestionsConsult,
        lockDraft: true
      };
    }
    session.lastHandle = handle;
    const live = liveProduct(handle);
    const price = productPrice(handle) || p.priceLabel || p.priceFallback || '';
    const inStock = productAvailable(handle);
    /* Prefer short barber copy — never dump live INCI / long PDP body into chat */
    const desc = p.storefrontCopy || p.summary || trimChatCopy(p.liveDescription || (live && live.description) || '');
    const howTo = p.howToLive || (p.application || []).map((s) => s).join(' ');
    const paired = inStock ? formatPairingSuggestion(handle, {}) : { html: '', companion: null };
    const facts = productFactsLine(handle);
    let html = `<p><strong>${escapeHtml(p.name)}</strong>${price ? ` — ${escapeHtml(price)}` : ''}${p.badge ? ` · <em>${escapeHtml(p.badge)}</em>` : ''}</p>`;
    if (!inStock) html += `<p><em>Currently unavailable / out of stock</em> — still part of the 4U range; check back or email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`;
    if (facts) html += `<p>${escapeHtml(facts)}</p>`;
    if (desc) html += `<p>${escapeHtml(desc)}</p>`;
    html += `<p>${escapeHtml(p.hold)} hold · ${escapeHtml(p.finish)} finish (${escapeHtml(p.finishPlain)}).</p>`;
    if (p.waterSoluble) html += `<p>Water-soluble — washes out with standard shampoo when used as directed.</p>`;
    if (howTo) html += `<p>${escapeHtml(howTo)}</p>`;
    if (p.tip) html += `<p>${escapeHtml(p.tip)}</p>`;
    if (paired.html) html += paired.html;
    html += `<p><a href="${SHOP}${productUrl(handle)}">View ${escapeHtml(p.name)} →</a></p>`;
    const chips = ['Recommend for my hair', 'What else is in the range?'];
    if (paired.companion && paired.companion.suggestion) chips.unshift(paired.companion.suggestion);
    else chips.unshift('What pairs with it?');
    chips.push('How do I use it?');
    return {
      html,
      suggestions: chips.slice(0, 4),
      voicePass: true,
      lockDraft: true,
      primaryHandle: handle
    };
  }

  function answerRange() {
    const lines = knowledgeProductHandles().map((h) => {
      const p = PRODUCT_KB[h];
      const price = productPrice(h) || p.priceLabel || p.priceFallback || '';
      const badge = p.badge ? ` · ${escapeHtml(p.badge)}` : '';
      const stock = productAvailable(h) ? '' : ' · <em>currently unavailable</em>';
      return `• <strong>${escapeHtml(p.name)}</strong>${price ? ` — ${escapeHtml(price)}` : ''}${p.size ? ` (${escapeHtml(p.size)})` : ''}${badge}${stock}<br><span style="opacity:.85">Hold: ${escapeHtml(p.hold)} · Finish: ${escapeHtml(p.finish)}</span>`;
    }).join('<br><br>');
    return {
      html: `<p>${escapeHtml(BRAND_FACTS.rangeLine)}</p>
             <p>${lines}</p>
             <p>${escapeHtml(BRAND_FACTS.sizes)} Free UK shipping over £${FREE}.</p>
             <p>Tell me your hair length and the finish you want and I’ll pick one.</p>`,
      suggestions: suggestionsConsult,
      voicePass: true,
      lockDraft: true
    };
  }

  /** Phrase/keyword intents — scored so paraphrases still hit (owner / runs / founded…). */
  function scorePhrases(q, phrases) {
    let score = 0;
    phrases.forEach((phrase) => {
      const p = normalize(phrase);
      if (!p) return;
      if (q === p) score += 50;
      else if (q.indexOf(p) !== -1) score += 12 + Math.min(20, p.length);
    });
    return score;
  }

  function scoreKeywords(q, keywords) {
    const tokens = new Set(q.split(' ').filter(Boolean));
    let score = 0;
    keywords.forEach((kw) => {
      const k = normalize(kw);
      if (!k) return;
      if (tokens.has(k) || q.indexOf(k) !== -1) score += k.length > 4 ? 6 : 4;
    });
    return score;
  }

  function faqMatch(query) {
    const q = normalize(query);
    const intents = [
      {
        id: 'greeting',
        min: 20,
        phrases: ['hi', 'hello', 'hey', 'hiya', 'good morning', 'good afternoon', 'good evening'],
        keywords: []
      },
      {
        id: 'thanks',
        min: 18,
        phrases: ['thanks', 'thank you', 'cheers', 'ta', 'appreciate it'],
        keywords: []
      },
      {
        id: 'guardrail',
        min: 14,
        phrases: ['hair loss', 'balding', 'regrow', 'repair damage', 'scalp psoriasis', 'scalp eczema', 'medical advice', 'allergic', 'allergy'],
        keywords: ['bald', 'alopecia', 'psoriasis', 'eczema', 'medical']
      },
      {
        id: 'founder',
        min: 12,
        phrases: [
          'who runs', 'who owns', 'who own', 'owner of', 'who is the owner', 'who\'s the owner',
          'who founded', 'who started', 'who created', 'who made 4u', 'who is behind',
          'brand story', 'about the brand', 'about 4u', 'meet the founder', 'founder',
          'ceo', 'who is bradley', 'bradley connellan', 'connellan', 'about brand'
        ],
        keywords: ['founder', 'owner', 'bradley', 'connellan', 'runs', 'owns', 'started', 'created', 'behind', 'brand']
      },
      {
        id: 'shipping',
        min: 12,
        phrases: [
          'shipping', 'delivery', 'deliver', 'postage', 'how much to ship', 'shipping cost',
          'free shipping', 'ship to', 'do you ship', 'international', 'abroad', 'overseas',
          'how long does delivery', 'when will it arrive', 'dispatch'
        ],
        keywords: ['ship', 'shipping', 'delivery', 'postage', 'courier', 'international', 'scotland', 'wales']
      },
      {
        id: 'policies',
        min: 12,
        phrases: [
          'terms and conditions', 'terms & conditions', 'terms of service', 'terms of sale',
          'privacy policy', 'privacy', 'data protection', 'gdpr', 'cookies', 'cookie policy',
          'legal', 'policies', 'your policies', 'refund policy', 'returns policy',
          'shipping policy', 'where are the terms', 't&cs', 't and cs', 'tncs',
          'terms & conditions', 'terms and conditions'
        ],
        keywords: [
          'terms', 'conditions', 'privacy', 'gdpr', 'cookie', 'cookies', 'legal',
          'policy', 'policies', 'tos'
        ]
      },
      {
        id: 'returns',
        min: 14,
        phrases: ['return', 'refund', 'exchange', 'damaged', 'wrong item', 'send back', 'money back'],
        keywords: ['return', 'refund', 'exchange', 'damaged']
      },
      {
        id: 'order',
        min: 14,
        phrases: ['track my order', 'order status', 'where is my order', 'has it shipped', 'order number', 'my order'],
        keywords: ['track', 'tracking', 'order']
      },
      {
        id: 'wholesale',
        min: 14,
        phrases: ['wholesale', 'trade account', 'bulk order', 'stockist', 'stock my salon', 'barber supply', 'for my barbershop'],
        keywords: ['wholesale', 'trade', 'bulk', 'stockist', 'salon']
      },
      {
        id: 'payment',
        min: 14,
        phrases: ['payment', 'shop pay', 'apple pay', 'google pay', 'pay by card', 'checkout', 'credit card', 'debit card'],
        keywords: ['payment', 'pay', 'checkout', 'card', 'paypal']
      },
      {
        id: 'discount',
        min: 12,
        phrases: ['discount', 'promo code', 'coupon', 'newsletter', 'welcome10', '10% off', 'first order discount', 'voucher'],
        keywords: ['discount', 'promo', 'coupon', 'newsletter', 'voucher', 'code']
      },
      {
        id: 'ingredients',
        min: 10,
        phrases: [
          'are they vegan', 'is it vegan', 'vegan', 'cruelty free', 'cruelty-free',
          'paraben', 'sulphate', 'sulfate', 'ingredients', 'made in the uk', 'made in uk',
          'what\'s in', 'whats in', 'barber approved', 'safe for', 'natural ingredients',
          'how ethical', 'are they ethical', 'ethical', 'ethics', 'ethically made',
          'environmentally friendly', 'eco friendly', 'sustainable', 'responsibly sourced',
          'tested on animals', 'animal testing', 'fair trade'
        ],
        keywords: [
          'vegan', 'cruelty', 'paraben', 'sulphate', 'sulfate', 'ingredients', 'uk',
          'ethical', 'ethics', 'ethically', 'sustainable', 'environment', 'eco', 'sourced'
        ]
      },
      {
        id: 'contact',
        min: 12,
        phrases: [
          'contact', 'email', 'speak to someone', 'talk to a human', 'customer service', 'support',
          'instagram', 'tiktok', 'socials', 'how do i reach', 'phone number', 'contact us', 'contact email'
        ],
        keywords: ['contact', 'email', 'support', 'instagram', 'tiktok', 'human', 'helpdesk']
      },
      {
        id: 'hours',
        min: 14,
        phrases: ['opening hours', 'what time', 'when are you open', 'business hours', 'office hours'],
        keywords: ['hours', 'open', 'closed']
      },
      {
        id: 'location',
        min: 12,
        phrases: ['where are you based', 'where is 4u', 'location', 'address', 'physical store', 'shop address', 'are you a shop'],
        keywords: ['based', 'location', 'address', 'storefront']
      },
      {
        id: 'range',
        min: 14,
        phrases: [
          'what products', 'what do you sell', 'full range', 'product list', 'your range',
          'all products', 'catalogue', 'catalog', 'what have you got', 'what\'s in the range',
          'what else is in the range', 'show the range', 'compare the range'
        ],
        keywords: ['range', 'catalogue', 'catalog']
      },
      {
        id: 'not_sold',
        min: 16,
        phrases: ['do you sell gel', 'have you got gel', 'any gel', 'pomade', 'mousse', 'hair oil', 'shampoo', 'conditioner'],
        keywords: ['gel', 'pomade', 'mousse', 'shampoo', 'conditioner']
      },
      {
        id: 'wax',
        min: 12,
        phrases: ['hair wax', 'do you sell wax', 'any wax', 'wax for hair', 'want wax', 'need wax', 'looking for wax', 'i want wax'],
        keywords: ['wax']
      },
      {
        id: 'howto',
        min: 14,
        phrases: ['how do i use', 'how to use', 'how do i apply', 'how to apply', 'instructions', 'application'],
        keywords: ['use', 'apply', 'instructions', 'application']
      },
      {
        id: 'price',
        min: 14,
        phrases: ['how much', 'what price', 'pricing', 'cost of', 'prices'],
        keywords: ['price', 'cost', 'pricing', 'expensive', 'cheap']
      },
      {
        id: 'compare',
        min: 12,
        phrases: ['difference between', 'compare', 'vs', 'versus', 'which is better', 'grooming clay or matte', 'compare the range'],
        keywords: ['difference', 'compare', 'versus', 'vs']
      },
      {
        id: 'pairing',
        min: 14,
        phrases: ['use together', 'layer', 'combo', 'more than one', 'pair with', 'can i use both', 'texture spray + paste', 'grooming clay + spray', 'curl cream pairing'],
        keywords: ['layer', 'combo', 'together', 'pairing', 'pair']
      },
      {
        id: 'amount',
        min: 14,
        phrases: ['how much product', 'how much should i use', 'how much do i use', 'start with a small'],
        keywords: ['amount', 'pea']
      },
      {
        id: 'gift',
        min: 14,
        phrases: ['gift card', 'gift voucher', 'present', 'gift for him', 'gift set'],
        keywords: ['gift', 'present', 'voucher']
      },
      {
        id: 'subscription',
        min: 16,
        phrases: ['subscription', 'subscribe', 'auto delivery', 'repeat order', 'subscribe and save'],
        keywords: ['subscription', 'subscribe']
      },
      {
        id: 'her',
        min: 16,
        phrases: ['for women', 'for her', '4her', 'ladies', 'women\'s'],
        keywords: ['women', 'ladies', 'her', '4her']
      },
      {
        id: 'help',
        min: 22,
        phrases: ['what can you do', 'what can you help with', 'what do you know', 'how can you help'],
        keywords: []
      }
    ];

    let best = null;
    let bestScore = 0;
    intents.forEach((intent) => {
      let score = scorePhrases(q, intent.phrases) + scoreKeywords(q, intent.keywords || []);
      /* Boost exact short greetings / thanks */
      if (intent.id === 'greeting' && /^(hi|hello|hey|hiya|good (morning|afternoon|evening))[\s!.]*$/.test(q)) score += 40;
      if (intent.id === 'thanks' && /^(thanks|thank you|cheers|ta)[\s!.]*$/.test(q)) score += 40;
      /* Owner / runs questions often miss “founder” — boost brand + ownership verbs */
      if (intent.id === 'founder' && /\b(who|whose)\b/.test(q) && /\b(run|runs|own|owns|owner|behind|start|started|found|founded|create|created|ceo)\b/.test(q)) {
        score += 30;
      }
      if (intent.id === 'founder' && /\b(bradley|connellan|founder|owner)\b/.test(q)) score += 20;
      if (intent.id === 'ingredients' && /\b(ethical|ethics|ethically|vegan|cruelty|sustainable|eco)\b/.test(q)) score += 25;
      /* Avoid treating product-name-only as “range” */
      if (intent.id === 'range' && findKbByQuery(query)) score -= 20;
      /* Wax shouldn’t win if they said texture paste */
      if (intent.id === 'wax' && /texture paste|paste/.test(q)) score -= 30;
      /* Gel/not_sold shouldn’t win when they mention clay/cream/paste/spray */
      if (intent.id === 'not_sold' && /clay|paste|cream|spray|curl/.test(q)) score -= 40;
      /* Price + shipping: prefer shipping if both */
      if (intent.id === 'price' && /ship|delivery|postage/.test(q)) score -= 25;
      if (intent.id === 'howto' && !/how|use|apply|instruction/.test(q)) score -= 10;
      if (score >= intent.min && score > bestScore) {
        bestScore = score;
        best = intent.id;
      }
    });
    return best ? { id: best, score: bestScore } : null;
  }

  function wantsConsult(query, attrs) {
    const q = normalize(query);
    /* Definitions / education — but not when they already gave a style brief */
    const hasStyleBrief = !!(attrs.finish || attrs.hold || attrs.style || attrs.length || attrs.wantWaxOrClay || attrs.wantMovement);
    if (isEducationOrAdjacentQuery(q) && retrieveKnowledge(query) && !hasStyleBrief) return false;
    /* “How about…” is a consult pivot, not a definition ask */
    if (/^how about\b/.test(q) && hasStyleBrief) return true;

    const attrKeys = Object.keys(attrs).filter((k) => !/^want/.test(k) && attrs[k]);
    if (session.questionsAsked > 0) {
      if (attrKeys.length) return true;
      if (/^(short|medium|long|matte|shine|natural|flexible|strong|maximum|fine|thick|straight|wavy|curly|yes|no)[\s!.]*$/.test(q)) return true;
    }
    if (/best for|what should i|which product|recommend|suggest|help me choose|what product should|pick (a |me )?(product|one)|recommend another/.test(q)) return true;
    if (/hate crunch|crunchy|stiff hairspray|don't like hairspray|do not like hairspray/.test(q)) return true;
    /* Curly / wavy / frizz product asks → consult (Curl Cream), not generic education only */
    if ((attrs.pattern === 'curly' || attrs.pattern === 'coily' || attrs.pattern === 'wavy' || /curl|curly|frizz|coily|\bwaves?\b/.test(q)) &&
        /what|which|should|use|recommend|suggest|need|for my|product|best/.test(q)) {
      return true;
    }
    /* Thickness alone → knowledge tips, not empty questionnaire */
    if (attrKeys.length === 1 && attrs.thickness && !attrs.pattern && !attrs.finish && !attrs.hold && !attrs.style) return false;
    /* Pattern alone with no product ask → education tip */
    if (attrKeys.length === 1 && attrs.pattern && !attrs.finish && !attrs.hold && !attrs.style &&
        !/what|which|should|use|recommend|suggest|need|product|best/.test(q)) return false;
    /* Short style cues: “strong with shine”, “matte + flexible”, etc. */
    if (attrs.finish && attrs.hold) return true;
    if (attrs.wantWaxOrClay) return true;
    if (attrKeys.length >= 2) return true;
    if (attrs.style) return true;
    if (attrKeys.length >= 1 && /hair|style|look|hold|finish|want|need|for my|with|and|\+/.test(q) && !/what (is|does|do)|mean|difference|how (do|does|to) wash/.test(q)) return true;
    if (/(textured )?crop|skin fade|quiff|side part|side parting|curtain|frizz|volume|lift|matte finish|no shine|\bshine\b|\bmatte\b|wet look/.test(q) && !isEducationOrAdjacentQuery(q)) return true;
    return false;
  }

  function answerFaq(route, query) {
    const q = normalize(query);
    const named = findKbByQuery(query);

    if (route === 'greeting') {
      return {
        html: `<p>${escapeHtml(cfg.greeting || 'Hi — I’m the 4U Virtual Barber. Ask me about products, shipping, the brand, or the look you’re going for.')}</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'thanks') {
      return { html: `<p>Anytime. Ask about another product, shipping, or the style you want next.</p>`, suggestions: suggestionsHelp };
    }
    if (route === 'help') {
      return {
        html: `<p>I can help with:</p>
               <p>• Product recommendations for your hair & finish<br>
               • How to use anything in the range<br>
               • Shipping, discounts & brand questions<br>
               • Terms, privacy & other store policies<br>
               • The brand story and what’s in the products</p>
               <p>What do you need?</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'guardrail') {
      return {
        html: `<p>I can’t give medical or hair-loss advice. Check the product label for ingredients, and speak to a qualified professional about scalp or health concerns.</p>
               <p>I can still help you choose a 4U styling product for the look you want.</p>`,
        suggestions: suggestionsConsult
      };
    }
    if (route === 'founder') return answerFounder();
    if (route === 'policies') {
      const qn = normalize(query);
      const terms = policyLink(['terms of service', 'terms of sale', 'terms'], 'Terms & Conditions');
      const privacy = policyLink(['privacy'], 'Privacy Policy');
      const refund = policyLink(['refund', 'return'], 'Refund policy');
      const shippingPol = policyLink(['shipping', 'delivery'], 'Shipping policy');

      if (/privacy|gdpr|data protection|personal data|my data/.test(qn)) {
        return {
          html: privacy
            ? `<p>How we handle your data is in our <strong>${privacy}</strong>.</p>
               <p>Questions about your info: <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
            : `<p>Our Privacy Policy is linked in the website footer. For data questions, email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`,
          suggestions: ['Terms & conditions', 'How do I return an order?', 'Contact us']
        };
      }
      if (/cookie/.test(qn)) {
        return {
          html: `<p>Cookie preferences are managed via the site’s cookie banner (footer / consent settings). For how we use data, see our ${privacy || 'Privacy Policy in the footer'}.</p>`,
          suggestions: ['Privacy policy', 'Terms & conditions', 'About the brand']
        };
      }
      if (/refund policy|returns policy/.test(qn)) {
        return {
          html: refund
            ? `<p>Returns and refunds are covered in our <strong>${refund}</strong>.</p>
               <p>Need help with an order? Email <a href="mailto:${EMAIL}">${EMAIL}</a> with your order number.</p>`
            : `<p>For returns or refunds, email <a href="mailto:${EMAIL}">${EMAIL}</a> with your order number — the team will guide you.</p>`,
          suggestions: ['How much is UK shipping?', 'Track my order', 'Terms & conditions']
        };
      }
      if (/shipping policy/.test(qn)) {
        return {
          html: shippingPol
            ? `<p>Delivery details are in our <strong>${shippingPol}</strong>.</p>
               <p>Quick version: UK shipping is <strong>${SHIP}</strong>, free over <strong>£${FREE}</strong>.</p>`
            : `<p>UK shipping is <strong>${SHIP}</strong>, free over <strong>£${FREE}</strong>. Full details are in the footer policies, or ask me about shipping.</p>`,
          suggestions: ['Is shipping free over £30?', 'Do you ship internationally?', 'Terms & conditions']
        };
      }
      if (/term|t&c|tnc|legal|condition|tos|sale/.test(qn)) {
        return {
          html: terms
            ? `<p>Our <strong>${terms}</strong> cover using the site and buying from 4U.</p>
               ${privacy ? `<p>Data & privacy: ${privacy}.</p>` : ''}
               <p>Anything specific you’re unsure about — email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
            : `<p>Terms & Conditions are linked in the website footer. For a specific question, email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`,
          suggestions: ['Privacy policy', 'Refund policy', 'How much is UK shipping?']
        };
      }
      /* General “policies / legal” ask */
      return {
        html: `<p>Here’s where the legal detail lives:</p>${allPolicyLinksHtml()}
               <p>I can also help with shipping costs, returns via email, or product advice.</p>`,
        suggestions: suggestionsPolicies.slice()
      };
    }
    if (route === 'shipping') {
      return { html: answerShipping(query), suggestions: ['Is shipping free over £30?', 'Do you ship internationally?', 'Recommend a product'] };
    }
    if (route === 'returns' || route === 'order' || route === 'wholesale') {
      const topic = route === 'wholesale' ? 'wholesale / stockist enquiries' : route === 'returns' ? 'returns, refunds or exchanges' : 'order tracking & delivery updates';
      const refund = route === 'returns' ? policyLink(['refund', 'return'], 'Refund policy') : '';
      return {
        html: `<p>For ${topic}, email <a href="mailto:${EMAIL}">${EMAIL}</a>${route === 'order' || route === 'returns' ? ' with your order number' : ''} and the 4U team will help.</p>
               ${refund ? `<p>You can also read our ${refund}.</p>` : ''}`,
        suggestions: ['How much is UK shipping?', 'About the brand', 'Recommend a product']
      };
    }
    if (route === 'payment') {
      return {
        html: `<p>Checkout runs securely through Shopify — cards and Shop Pay / accelerated wallets where available. We never see your full card details.</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'discount') {
      return {
        html: `<p>Join the newsletter in the footer for <strong>10% off your first order</strong> (code shown after signup — typically <strong>${escapeHtml(DISCOUNT)}</strong>) and early access to new drops.</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'ingredients') {
      const claims = BRAND_FACTS.claims.map((c) => {
        const detail = BRAND_FACTS.claimDetails[c];
        return detail ? `• <strong>${escapeHtml(c)}</strong> — ${escapeHtml(detail)}` : `• ${escapeHtml(c)}`;
      }).join('<br>');
      const qn = normalize(query);
      const ethicalAsk = /\b(ethical|ethics|ethically|sustainable|eco|environment|cruelty|vegan|animals)\b/.test(qn);
      const wantsList = /\b(ingredient|ingredients|inci|what'?s in|whats in|what is in|allergen|parabens?|sulphates?|sulfates?)\b/.test(qn);
      const focus = named || session.lastHandle;
      if (wantsList && focus && PRODUCT_KB[focus] && PRODUCT_KB[focus].ingredients) {
        const p = PRODUCT_KB[focus];
        return {
          html: `<p>Here’s what’s in <strong>${escapeHtml(p.name)}</strong>:</p>
                 <p>${escapeHtml(p.ingredients)}</p>
                 <p>Also on the <a href="${SHOP}${productUrl(focus)}">product page</a>. Allergen questions: <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`,
          suggestions: suggestionsProduct.slice(),
          voicePass: false
        };
      }
      return {
        html: ethicalAsk
          ? `<p>On ethics, 4U is built to be a responsible choice:</p><p>${claims}</p>
             <p>No animal testing, vegan formulation, UK-made, and responsibly sourced ingredients where specified. Full INCI lists are on each product page — or email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`
          : `<p>Yes — across the 4U range:</p><p>${claims}</p>
             <p>Full ingredient lists live on each product page. Ask “ingredients in Grooming Clay” if you want a specific one, or email <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'contact') {
      const ig = SOCIAL.instagram ? `<br>Instagram: <a href="${SOCIAL.instagram}" target="_blank" rel="noopener">@4UHAIRPRODUCT</a>` : '';
      const tt = SOCIAL.tiktok ? `<br>TikTok: <a href="${SOCIAL.tiktok}" target="_blank" rel="noopener">@4uhairproducts</a>` : '';
      const tp = SOCIAL.trustpilot ? `<br>Trustpilot: <a href="${SOCIAL.trustpilot}" target="_blank" rel="noopener">4uhairproducts.com</a>` : '';
      return { html: `<p>Email <a href="mailto:${EMAIL}">${EMAIL}</a>${ig}${tt}${tp}</p>`, suggestions: suggestionsHelp };
    }
    if (route === 'hours') {
      return {
        html: `<p>4U is an online store — there’s no walk-in shop counter. For order or product questions, email <a href="mailto:${EMAIL}">${EMAIL}</a> and we’ll get back to you as soon as we can.</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'location') {
      return {
        html: `<p>4U Hair Products is a UK brand — products are <strong>Made in the UK</strong> and we sell online. There isn’t a public high-street storefront; order via the site and we’ll ship to you.</p>
               <p><a href="${SHOP}${BRAND.aboutUrl || '/#founder'}">Read the brand story →</a></p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'range') return answerRange();
    if (route === 'not_sold') {
      return {
        html: `<p>The current 4U range focuses on clays, creams, paste, texture spray and curl cream — we don’t sell gel, pomade, shampoo or conditioner as separate products.</p>
               <p>Tell me the hairstyle and finish you want, and I’ll recommend the closest match from the range.</p>`,
        suggestions: suggestionsConsult
      };
    }
    if (route === 'wax') {
      return {
        html: `<p>We don’t list a separate wax right now. <strong>4U Texture Paste</strong> is the flexible, natural, reworkable option most people mean when they ask for a wax-like product.</p>`,
        suggestions: ['Tell me about Texture Paste', 'Short + matte', 'Strong hold matte']
      };
    }
    if (route === 'gift') {
      return {
        html: `<p>We don’t currently sell gift cards. The easiest gift is any product from the <a href="${SHOP}${PRODUCTS_URL}">range</a> — or pick based on their hair length and finish and I can recommend one.</p>`,
        suggestions: suggestionsConsult
      };
    }
    if (route === 'subscription') {
      return {
        html: `<p>There’s no subscription / auto-delivery option right now — just order when you need a refill. Free UK shipping over £${FREE}.</p>`,
        suggestions: suggestionsHelp
      };
    }
    if (route === 'her') {
      const her = PRODUCT_KB['4u-4her-texture-spray'];
      if (cfg.show4her && her) {
        return {
          html: `<p><strong>4HER</strong> is our dedicated line — starting with <strong>${escapeHtml(her.name)}</strong> (${escapeHtml(her.size)}).</p>
                 <p>${escapeHtml(her.summary)}</p>
                 <p>${escapeHtml(her.application.join(' '))}</p>
                 <p>The core 4U range (clays, paste, cream, spray, curl cream) is for all hair types too — tell me length and finish if you want a pick from that.</p>`,
          suggestions: ['Tell me about 4HER spray', 'Recommend for my hair', 'Are products vegan?']
        };
      }
      return {
        html: `<p>4U products are for real hair types — not locked to one gender. Clays, paste, cream, texture spray and curl cream all work across short and longer styles.</p>
               <p>Tell me length + the look (matte, natural, curls, lift) and I’ll recommend from the range.</p>`,
        suggestions: suggestionsConsult
      };
    }
    if (route === 'amount') {
      return {
        html: `<p>Start with a <strong>small amount</strong>. Fine or short hair usually needs less; thick or long hair may need more. Build gradually rather than applying too much at once.</p>`,
        suggestions: suggestionsProduct.slice(),
        voicePass: true
      };
    }
    if (route === 'pairing') {
      const focus = named || session.lastHandle;
      if (focus && PRODUCT_KB[focus]) {
        const paired = formatPairingSuggestion(focus, { forcePairing: true });
        if (paired.html) {
          return {
            html: `<p>With <strong>${escapeHtml(shortProductName(focus))}</strong>, here’s the combo that usually makes sense:</p>${paired.html}
                   <p>I only suggest a second product when it improves the result — not to fill a basket.</p>`,
            suggestions: recommendationSuggestions(focus, { forcePairing: true }),
            voicePass: true
          };
        }
      }
      return {
        html: `<p>Yes — when the combo has a clear purpose. <strong>Texture Spray</strong> first for lift, then a clay, paste or cream to shape. If someone asks for a “wax” with the spray, <strong>Texture Paste</strong> is the flexible option in the range.</p>
               <p>Curl Cream goes on damp hair; any finishing product only after drying, and only a tiny amount.</p>
               <p>Tell me which product you’re looking at and I’ll name the best partner.</p>`,
        suggestions: ['Texture Spray + paste', 'Grooming Clay + spray', 'Curl Cream pairing', 'Recommend a product'],
        voicePass: true
      };
    }
    if (route === 'compare') {
      return {
        html: answerCompare(query),
        suggestions: ['Recommend a product', 'Tell me about Grooming Clay', 'Tell me about Texture Paste', 'What pairs with it?'],
        voicePass: true
      };
    }
    if (route === 'price') {
      if (named) {
        const p = PRODUCT_KB[named];
        const price = productPrice(named);
        return {
          html: `<p><strong>${escapeHtml(p.name)}</strong> is <strong>${escapeHtml(price || 'listed on the product page')}</strong>.</p>
                 <p>${escapeHtml(p.hold)} hold · ${escapeHtml(p.finishPlain)} finish.</p>
                 <p><a href="${SHOP}${productUrl(named)}">View product →</a></p>`,
          suggestions: suggestionsProduct.slice(),
          voicePass: true
        };
      }
      return answerRange();
    }
    if (route === 'howto') {
      const handle = named || session.lastHandle;
      if (!handle || !PRODUCT_KB[handle]) {
        return {
          html: `<p>Which product — Grooming Clay, Matte Clay, Texture Paste, Defining Cream, Texture Spray or Curl Cream?</p>`,
          suggestions: ['Grooming Clay', 'Texture Paste', 'Defining Cream', 'Curl Cream'],
          voicePass: true
        };
      }
      const p = PRODUCT_KB[handle];
      return {
        html: `<p>For <strong>${escapeHtml(p.name)}</strong>: ${p.application.map(escapeHtml).join(' ')}</p><p>${escapeHtml(p.tip)}</p>`,
        suggestions: ['What pairs with it?', 'How much product should I use?', 'Recommend a product', 'How much is UK shipping?'],
        voicePass: true
      };
    }
    return null;
  }

  function runConsult(query, attrs) {
    const q = normalize(query);
    const attrKeys = Object.keys(attrs).filter((k) => attrs[k] != null && attrs[k] !== false && !/^want/.test(k));
    const midQuestionnaire = session.questionsAsked > 0;
    const explicitRestart = /recommend another|start over|something else|different (product|style)|new recommendation/.test(q);
    /* Fresh multi-attr brief from a cold start — reset so old chat doesn't skew.
       Mid-questionnaire answers must MERGE, not wipe prior length/finish. */
    const selfContainedBrief = attrKeys.length >= 2 && !midQuestionnaire;

    if (explicitRestart || selfContainedBrief) {
      session.length = null;
      session.pattern = null;
      session.thickness = null;
      session.finish = null;
      session.hold = null;
      session.style = null;
      session.wantMovement = false;
      session.wantWaxOrClay = false;
      session.wantTravel = false;
      session.trueMatte = false;
      session.questionsAsked = 0;
    }
    mergeSession(attrs, query);

    if (
      /^(what|which) product/.test(q) ||
      /what should i (use|get|buy)/.test(q) ||
      /recommend (a |me )?(product|something)/.test(q) ||
      q === 'help' ||
      q === 'recommend'
    ) {
      if (Object.keys(attrs).length === 0) {
        session.length = null;
        session.pattern = null;
        session.thickness = null;
        session.finish = null;
        session.hold = null;
        session.style = null;
        session.wantMovement = false;
        session.wantWaxOrClay = false;
        session.wantTravel = false;
        session.trueMatte = false;
        session.questionsAsked = 0;
        return nextQuestion();
      }
    }

    const conf = confidence();
    const hasStyleSignal = !!(session.style || session.finish || session.hold || session.pattern || (session.length && attrs.length));
    const stylePrimary = STYLE_MAP.find((row) => row.style === session.style);
    const wantsCurlHero = !!(
      session.pattern === 'curly' ||
      session.pattern === 'coily' ||
      session.style === 'curl' ||
      /curl|curly|frizz|coily/.test(q) ||
      (session.pattern === 'wavy' && !session.wantMovement && !/paste|movement|flow|loose/.test(q))
    );

    /* Curls / waves / frizz — always Curl Cream before questionnaire gates */
    if (wantsCurlHero && productAvailable('curl-cream')) {
      session.style = session.style || 'curl';
      const wantLift = session.thickness === 'fine' || session.style === 'volume' || session.hold === 'maximum'
        || (session.length === 'long' && (session.hold === 'strong' || session.hold === 'maximum'))
        || /lift|volume|flat|all day|stay in place|quiff/.test(q);
      const opts = { wantLift };
      return {
        html: formatRecommendation('curl-cream', opts),
        suggestions: recommendationSuggestions('curl-cream', opts),
        voicePass: true,
        lockDraft: true,
        primaryHandle: 'curl-cream'
      };
    }

    /* Named style (quiff, side part, crop…) → recommend without more questionnaire */
    if (stylePrimary && session.style) {
      const pick = pickProduct();
      const handle = (pick && pick.score >= 5) ? pick.handle : stylePrimary.primary;
      const wantLift = session.thickness === 'fine' || session.style === 'volume' || session.hold === 'maximum'
        || (session.length === 'long' && (session.hold === 'strong' || session.hold === 'maximum'))
        || /lift|volume|flat|all day|stay in place|quiff/.test(q);
      const opts = { wantLift };
      return {
        html: formatRecommendation(handle, opts),
        suggestions: recommendationSuggestions(handle, opts),
        voicePass: true,
        lockDraft: true,
        primaryHandle: handle
      };
    }

    if (conf === 'low' && session.questionsAsked < 3 && !hasStyleSignal) return nextQuestion();
    if (conf === 'low' && knownCount() < 2 && session.questionsAsked < 3) return nextQuestion();

    const pick = pickProduct();
    if (!pick || pick.score < 5) return nextQuestion();

    const wantLift = session.thickness === 'fine' || session.style === 'volume' || session.hold === 'maximum'
      || (session.length === 'long' && (session.hold === 'strong' || session.hold === 'maximum'))
      || /lift|volume|flat|all day|stay in place|quiff/.test(q);
    const opts = { wantLift };
    return {
      html: formatRecommendation(pick.handle, opts),
      suggestions: recommendationSuggestions(pick.handle, opts),
      voicePass: true,
      lockDraft: true,
      primaryHandle: pick.handle
    };
  }

  function clarifyUnknown(query) {
    const fromKnowledge = answerFromKnowledge(query);
    if (fromKnowledge) return fromKnowledge;

    const named = findKbByQuery(query);
    if (named) return answerProductCard(named);

    const fieldHit = searchProductFields(query);
    if (fieldHit && fieldHit.score >= 16) {
      const p = PRODUCT_KB[fieldHit.handle];
      return {
        html: `<p>Closest match is <strong>${escapeHtml(p.name)}</strong> — ${escapeHtml(p.summary)}</p>
               <p>${escapeHtml(p.tip)}</p>
               <p><a href="${SHOP}${productUrl(fieldHit.handle)}">View ${escapeHtml(p.name)} →</a></p>`,
        suggestions: recommendationSuggestions(fieldHit.handle, {}),
        voicePass: true,
        lockDraft: true,
        primaryHandle: fieldHit.handle
      };
    }

    return {
      html: `<p>I might be slightly off-scope there — I’m strongest on 4U products, hold & finish, how to use them, shipping, and the brand.</p>
             <p>Try rephrasing, or ask something like “short matte hair”, “what pairs with texture spray”, or “about the brand”. For order issues: <a href="mailto:${EMAIL}">${EMAIL}</a>.</p>`,
      suggestions: suggestionsHelp,
      needsLlm: true
    };
  }

  const SERVICE_FAQ = {
    greeting: 1, thanks: 1, help: 1, guardrail: 1, founder: 1, shipping: 1,
    returns: 1, order: 1, wholesale: 1, payment: 1, discount: 1, ingredients: 1,
    contact: 1, hours: 1, location: 1, range: 1, not_sold: 1, wax: 1,
    gift: 1, subscription: 1, her: 1, policies: 1,
    /* Product service intents — must beat consult (e.g. “how much is grooming clay”) */
    price: 1, howto: 1, compare: 1, pairing: 1, amount: 1
  };

  /* ========== Main compose ========== */
  function composeAnswer(raw) {
    const query = String(raw || '').trim();
    /* Typo-aware query used for all matching ("wthical" → "ethical") */
    const q = normalizeQuery(query);
    const attrs = parseAttributes(q);
    const faq = faqMatch(q);
    const named = findKbByQuery(q);

    /* Chip / follow-up: “Texture Paste with it?” after a recommendation */
    if (
      session.lastHandle &&
      (/with it\b|underneath\b|pair(s|ed)? with|go(es)? with|alongside|on top/.test(q) ||
        (named && named !== session.lastHandle && /with|pair|\+/.test(q)))
    ) {
      const paired = lockReply(answerFaq('pairing', q));
      if (paired) return paired;
    }

    /* Product “what is / tell me about” cards — but style/reco phrasing goes to consult */
    const namedInfoAsk = named && /tell me about|what is|what's|whats|info|details|about the|who (is it )?for|what hair type|hair type|when (to|should)|should i use|best (for|hair) for/.test(q);
    const namedRecoWithStyle = named && /should i use|best for|what should i|which .*(for|with)|for (my )?(curl|curly|wavy|short|long|matte)/.test(q) &&
      !!(attrs.pattern || attrs.finish || attrs.hold || attrs.style || attrs.length || /curl|curly|frizz|coily|\bwaves?\b|matte|shine/.test(q));
    if (namedInfoAsk && !namedRecoWithStyle) {
      if (named === 'matte-clay' && /hair type|who (is it )?for|should i use|best for|suited/.test(q)) {
        const fromKnowledge = answerFromKnowledge(q);
        if (fromKnowledge) return fromKnowledge;
      }
      return answerProductCard(named);
    }

    /* Brand / service FAQs first — never dump these into the hair questionnaire */
    if (faq && SERVICE_FAQ[faq.id]) {
      /* Range / wax must not steal a real style brief (“what products for long hair…”)
         Bare wax/wantWax alone should still hit the wax FAQ → Texture Paste */
      const styleBrief = !!(attrs.finish || attrs.hold || attrs.style || attrs.length || attrs.wantMovement || attrs.pattern);
      if (!((faq.id === 'range' || faq.id === 'wax') && styleBrief)) {
        const answered = lockReply(answerFaq(faq.id, q));
        if (answered) return answered;
      }
    }

    /* Mid-consult replies & explicit style asks */
    if (wantsConsult(q, attrs)) {
      return runConsult(q, attrs);
    }

    /* Deep knowledge / education — after consult so “strong with shine” isn’t swallowed */
    if (isEducationOrAdjacentQuery(q)) {
      const fromKnowledge = answerFromKnowledge(q);
      if (fromKnowledge) return fromKnowledge;
    } else {
      const fromKnowledge = answerFromKnowledge(q);
      /* Only use weak knowledge hits when nothing looks like a product ask */
      if (fromKnowledge && !(attrs.finish || attrs.hold || attrs.style)) return fromKnowledge;
    }

    /* Product how-to / price / compare / pairing */
    if (faq) {
      const answered = lockReply(answerFaq(faq.id, q));
      if (answered) return answered;
    }

    /* Broader product-field retrieval (tips, use-cases, aliases) */
    const fieldHit = searchProductFields(q);
    if (fieldHit && fieldHit.score >= 18 && !wantsConsult(q, attrs)) {
      return answerProductCard(fieldHit.handle);
    }

    if (named) return answerProductCard(named);

    const lateKnowledge = answerFromKnowledge(q);
    if (lateKnowledge) return lateKnowledge;

    return clarifyUnknown(q);
  }

  function htmlToPlain(html) {
    return String(html || '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/[ \t]{2,}/g, ' ')
      .trim();
  }

  function sessionSnapshot() {
    const bits = [];
    if (session.length) bits.push('length=' + session.length);
    if (session.pattern) bits.push('pattern=' + session.pattern);
    if (session.thickness) bits.push('thickness=' + session.thickness);
    if (session.finish) bits.push('finish=' + session.finish);
    if (session.hold) bits.push('hold=' + session.hold);
    if (session.style) bits.push('style=' + session.style);
    if (session.wantMovement) bits.push('wants-movement');
    if (session.wantWaxOrClay) bits.push('asked-wax/clay');
    if (session.trueMatte) bits.push('true-matte');
    if (session.lastHandle && PRODUCT_KB[session.lastHandle]) {
      bits.push('lastProduct=' + PRODUCT_KB[session.lastHandle].name);
    }
    return bits.length ? bits.join(', ') : 'none yet';
  }

  function noteRecommendedFromReply(html) {
    const plain = htmlToPlain(html).toLowerCase();
    let best = null;
    visibleProductHandles().forEach((h) => {
      const p = PRODUCT_KB[h];
      const name = String(p.name || '').toLowerCase();
      const short = name.replace(/^4u\s+/i, '');
      if (name && plain.indexOf(name) !== -1) best = h;
      else if (short.length > 4 && plain.indexOf(short) !== -1) best = h;
      else if (plain.indexOf('/products/' + h) !== -1) best = h;
    });
    if (best) session.lastHandle = best;
  }

  const chatHistory = [];

  function pushChatHistory(role, content) {
    const text = htmlToPlain(content).slice(0, 700);
    if (!text) return;
    chatHistory.push({ role: role === 'assistant' ? 'assistant' : 'user', content: text });
    while (chatHistory.length > 10) chatHistory.shift();
  }

  function buildLlmContext(local) {
    const handles = knowledgeProductHandles();
    const rangeNames = handles.map((h) => PRODUCT_KB[h].name).join(', ');
    const products = handles.map((h) => {
      const p = PRODUCT_KB[h];
      const url = (SHOP || '') + productUrl(h);
      const stock = productAvailable(h) ? 'in stock' : 'CURRENTLY UNAVAILABLE (still in range — do not deny existence)';
      return [
        p.name,
        `handle ${h}`,
        `link ${url}`,
        `SKU ${p.sku || 'n/a'}`,
        p.size || '',
        stock,
        `Hold: ${p.hold}`,
        `Finish: ${p.finish} (${p.finishPlain})`,
        p.storefrontCopy || p.summary,
        `How to: ${(p.howToLive || (p.application || []).join(' '))}`,
        `Tip: ${p.tip}`,
        `Price: ${productPrice(h) || p.priceLabel || p.priceFallback || 'see site'}`,
        p.badge ? `Badge: ${p.badge}` : '',
        p.waterSoluble ? 'Water-soluble' : '',
        `Best for lengths: ${(p.lengths || []).join('/')}`,
        `Styles: ${(p.styles || []).slice(0, 6).join(', ')}`
      ].filter(Boolean).join(' | ');
    }).join('\n');

    const claimLines = BRAND_FACTS.claims.map((c) => {
      const d = BRAND_FACTS.claimDetails[c];
      return d ? `${c}: ${d}` : c;
    }).join('; ');

    const lines = [
      `You are the 4U Virtual Barber for ${BRAND.name || '4U Hair Products'}.`,
      'Speak like a real UK barber: warm, direct, conversational — never scripted or catalogue-like.',
      BRAND_FACTS.positioning,
      BRAND_FACTS.rangeLine,
      `FULL RANGE (all real 4U products — never deny these): ${rangeNames}`,
      `Tagline: ${BRAND_FACTS.tagline}`,
      `Founder: ${BRAND.founder || 'Bradley Connellan'} (${BRAND_FACTS.founderTitle}). ${BRAND.founderBio || BRAND_FACTS.founderBio}`,
      `Story: ${BRAND.story || BRAND_FACTS.founderBio}`,
      `UK shipping ${SHIP}, free over £${FREE}. Support: ${EMAIL}. Newsletter code typically ${DISCOUNT} (10% first order).`,
      `Claims: ${claimLines}`,
      `Not sold: ${BRAND_FACTS.notSold.join(', ')}. Wax / clay-wax requests → Texture Paste.`,
      `Sizes: ${BRAND_FACTS.sizes}`,
      `Social: IG @4UHAIRPRODUCT, TikTok @4uhairproducts, Trustpilot 4uhairproducts.com`,
      `Shop base: ${SHOP || '(relative product links OK)'}`,
      `Products:\n${products}`,
      `Consult memory this chat: ${sessionSnapshot()}`,
      'HARD ROUTING (must follow): curly / coily / wavy / frizz / curl definition → lead with 4U Curl Cream on damp hair. NEVER recommend Defining Cream as the main product for curly or wavy hair — Defining Cream is for neat polished styles with light shine on straighter / controlled looks. Texture Paste is for flexible natural movement on medium–long, not curl definition.',
      'Decision cues: short+matte → Grooming Clay or Matte Clay; flexible natural / medium-long movement → Texture Paste; neat+shine (not curls) → Defining Cream; volume/lift/fine/flat → Texture Spray; curls/waves/frizz → Curl Cream on damp hair (primary).',
      'Rules: Use only facts above + conversation. Never invent SKUs, sizes, or products. Never say a listed product is not sold. No medical/hair-loss advice. Prefer one clear recommendation + optional pairing. Short answers. £ and UK English. Never dump full ingredient lists unless asked — point to the product page. When recommending a product, the name MUST be an HTML link using the exact product URL from the product facts, e.g. <a href="/products/curl-cream"><strong>4U Curl Cream</strong></a>.'
    ];

    if (local && local.primaryHandle && PRODUCT_KB[local.primaryHandle]) {
      const p = PRODUCT_KB[local.primaryHandle];
      const heroDraft = formatRecommendation(local.primaryHandle, { skipPairing: true });
      lines.push(
        `PRIMARY PICK (required): Recommend ${p.name} first (${productLinkHref(local.primaryHandle)}). Do not swap it for a different hero product.`
      );
      lines.push(
        'Local barber-engine hint (hero only — write your own natural reply; do not copy labelled blocks or dump ingredients): ' +
          htmlToPlain(heroDraft).slice(0, 900)
      );
    } else if (local && local.html) {
      const hint = htmlToPlain(local.html).slice(0, 900);
      if (hint) {
        lines.push(
          'Local barber-engine hint (guidance only — write your own natural reply; do not copy labelled blocks or dump ingredients): ' + hint
        );
      }
    }

    return lines.join('\n');
  }

  function productLinkHref(handle) {
    const path = productUrl(handle);
    if (/^https?:\/\//i.test(path)) return path;
    return (SHOP || '') + path;
  }

  function productNamePatterns() {
    const entries = [];
    knowledgeProductHandles().forEach((h) => {
      const p = PRODUCT_KB[h];
      if (!p) return;
      const names = [p.name]
        .concat(p.aliases || [])
        .concat([String(p.name || '').replace(/^4U\s+/i, '')])
        .filter(Boolean);
      const seen = {};
      names.forEach((n) => {
        const key = String(n).toLowerCase().trim();
        if (!key || key.length < 4 || seen[key]) return;
        /* Skip ultra-generic aliases that would false-link ("grooming", "paste") */
        if (/^(grooming|paste|clay|cream|spray|curl)$/i.test(key)) return;
        seen[key] = true;
        entries.push({ handle: h, name: String(n).trim() });
      });
    });
    entries.sort((a, b) => b.name.length - a.name.length);
    return entries;
  }

  /** Ensure product names in GPT replies are clickable product-page links */
  function linkProductsInHtml(html) {
    let out = String(html || '');
    if (!out) return out;

    /* Markdown links → HTML */
    out = out.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+|\/products\/[^)\s]+)\)/gi, (_, label, url) => {
      return `<a href="${escapeHtml(url.trim())}"><strong>${escapeHtml(label)}</strong></a>`;
    });

    const entries = productNamePatterns();
    const linkedHandles = {};

    /* Already-linked product URLs count as done */
    knowledgeProductHandles().forEach((h) => {
      if (new RegExp('/products/' + h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i').test(out)) {
        linkedHandles[h] = true;
      }
    });

    const parts = out.split(/(<a\b[^>]*>[\s\S]*?<\/a>)/gi);
    out = parts.map((part) => {
      if (/^<a\b/i.test(part)) return part;
      let chunk = part;
      entries.forEach(({ handle, name }) => {
        if (linkedHandles[handle]) return;
        const esc = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp('(^|[^\\w/])(' + esc + ')(?![\\w])', 'i');
        if (!re.test(chunk)) return;
        linkedHandles[handle] = true;
        const href = escapeHtml(productLinkHref(handle));
        chunk = chunk.replace(re, `$1<a href="${href}"><strong>$2</strong></a>`);
      });
      return chunk;
    }).join('');

    return out;
  }

  function ensureRecommendedProductLinks(html, local) {
    let out = linkProductsInHtml(html);

    /* Only force a CTA for the hero product — never orphan companion links from pairing HTML */
    const primary = local && local.primaryHandle;
    if (!primary || !PRODUCT_KB[primary]) return out;

    const href = productLinkHref(primary);
    const path = productUrl(primary);
    if (
      out.indexOf('/products/' + primary) !== -1 ||
      out.indexOf(path) !== -1 ||
      out.indexOf(href) !== -1
    ) {
      return out;
    }

    const p = PRODUCT_KB[primary];
    out += `<p><a href="${escapeHtml(href)}"><strong>${escapeHtml(p.name)}</strong></a></p>`;
    return out;
  }

  function llmReplyToHtml(text) {
    let raw = String(text || '').trim();
    if (!raw) return '';

    /* Preserve GPT HTML; convert markdown links in plain replies before escaping */
    const hasHtml = /<p|<br|<strong|<a /i.test(raw);
    if (hasHtml) return raw;

    const held = [];
    raw = raw.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, label, url) => {
      const i = held.length;
      held.push(`<a href="${escapeHtml(url.trim())}"><strong>${escapeHtml(label)}</strong></a>`);
      return `\0L${i}\0`;
    });

    const paras = raw.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
    const wrap = (p) => {
      let t = escapeHtml(p).replace(/\n/g, '<br>');
      t = t.replace(/\0L(\d+)\0/g, (_, i) => held[+i] || '');
      return `<p>${t}</p>`;
    };
    if (paras.length > 1) return paras.map(wrap).join('');
    return wrap(raw);
  }

  function gptDeniesKnownRange(html) {
    const plain = htmlToPlain(html).toLowerCase();
    if (!plain) return false;
    return /don'?t (sell|stock|have|carry)|do not (sell|stock|have|carry)|we('ve| have) never (sold|stocked)|not (something |a product )?we (sell|stock|carry)|isn'?t in (our |the )?range|not in (our |the )?range|i don'?t think we/.test(plain);
  }

  async function composeAnswerAsync(raw) {
    /* Local engine updates consult session + supplies fallback / suggestion chips */
    const local = composeAnswer(raw);
    const endpoint = (cfg.apiEndpoint || cfg.llmEndpoint || '').trim();
    if (!endpoint) return local;

    const customerMsg = String(raw || '').trim();
    if (!customerMsg) return local;

    /* Confident local facts → polish draft (locks products/prices; GPT only voices it).
       Free answer only when local has no solid product/range draft. */
    const lockDraft = !!(local.html && (local.lockDraft || local.primaryHandle || local.voicePass));
    const mode = lockDraft ? 'polish' : 'answer';

    try {
      const payload = {
        message: customerMsg,
        context: buildLlmContext(local),
        history: chatHistory.slice(-8),
        mode
      };
      if (mode === 'polish') {
        /* Prefer the local reply HTML so product-info cards stay intact.
           Consult picks without a custom card still use the recommendation formatter. */
        payload.draft = local.lockDraft || local.voicePass || !local.primaryHandle
          ? local.html
          : (formatRecommendation(local.primaryHandle, { skipPairing: true }) || local.html);
        payload.message = [
          `Customer said: ${customerMsg}`,
          '',
          'Rewrite this draft reply as the 4U Virtual Barber — warm, direct UK barber chat, not a catalogue.',
          'Keep the same hero product and every price, size, link and fact. Keep <a> and <strong> tags.',
          'Do not swap the recommended product. Do not add full ingredient lists. Do not add extra products that are not in the draft.',
          'Do not use labelled blocks like Hold: / Finish: / Barber tip:.',
          'Do not claim a product is missing from the range if it appears in the draft or product facts.',
          '',
          'Draft:',
          payload.draft
        ].join('\n');
      }

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) return local;
      const data = await res.json();
      const text = (data && (data.reply || data.message || data.html)) || '';
      if (!text) return local;

      let html = llmReplyToHtml(text);
      /* If GPT denies a product we know about, keep the local barber answer */
      if (gptDeniesKnownRange(html) && local.html) return local;

      html = ensureRecommendedProductLinks(html, local);
      noteRecommendedFromReply(html);
      return {
        html,
        suggestions: data.suggestions || local.suggestions || suggestionsHelp
      };
    } catch (e) {
      return local;
    }
  }

  function defaultSuggestions() {
    return suggestionsHelp.slice();
  }

  /* ========== UI (mobile sheet + desktop widget) ========== */
  function init() {
    const root = document.querySelector('[data-chat-root]');
    if (!root) return;

    const panel = document.getElementById('fouruChatPanel');
    const messages = root.querySelector('[data-chat-messages]');
    const suggestionsEl = root.querySelector('[data-chat-suggestions]');
    const form = root.querySelector('[data-chat-form]');
    const input = root.querySelector('[data-chat-input]');
    const sendBtn = root.querySelector('[data-chat-send]');
    const toggleBtn = root.querySelector('#fouruChatLauncher') || root.querySelector('[data-chat-toggle]');
    const toggleTargets = [...root.querySelectorAll('[data-chat-toggle]')];
    const closeBtn = root.querySelector('[data-chat-close]');
    const teaserEl = root.querySelector('[data-chat-teaser]');
    const teaserDismissBtn = root.querySelector('[data-chat-teaser-dismiss]');
    const stickyCart = document.getElementById('stickyCart');
    const TEASER_KEY = 'fouru_chat_teaser_dismissed';

    root.hidden = false;
    let open = false;
    let busy = false;
    let greeted = false;
    let lastFocus = null;
    let scrollY = 0;

    root.classList.remove('is-open');
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');

    function teaserDismissed() {
      try {
        return Boolean(localStorage.getItem(TEASER_KEY));
      } catch (e) {
        return false;
      }
    }

    function hideTeaser(persist) {
      if (!teaserEl) return;
      teaserEl.hidden = true;
      if (!persist) return;
      try { localStorage.setItem(TEASER_KEY, '1'); } catch (e) { /* */ }
    }

    function showTeaser() {
      if (!teaserEl || teaserDismissed() || open) return;
      teaserEl.hidden = false;
    }

    showTeaser();

    try {
      if (!localStorage.getItem('fouru_chat_seen') && teaserEl && teaserEl.hidden) {
        root.classList.add('fouru-chat--nudge');
        window.setTimeout(() => root.classList.remove('fouru-chat--nudge'), 7000);
      }
    } catch (e) { /* */ }

    function isMobileSheet() {
      return window.matchMedia('(max-width: 900px)').matches;
    }

    function syncStickyOffset() {
      if (open && isMobileSheet()) {
        root.classList.remove('fouru-chat--cart-hidden');
        return;
      }
      const cartVisible = stickyCart && stickyCart.classList.contains('visible');
      root.classList.toggle('fouru-chat--cart-hidden', !cartVisible);
    }
    syncStickyOffset();
    if (stickyCart && typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncStickyOffset).observe(stickyCart, { attributes: true, attributeFilter: ['class'] });
    }

    function syncSheetHeight() {
      if (!open || !isMobileSheet()) {
        root.style.removeProperty('--chat-sheet-height');
        return;
      }
      const vv = window.visualViewport;
      const vh = vv ? vv.height : window.innerHeight;
      const maxH = Math.max(280, Math.floor(vh - 24));
      const preferred = Math.min(Math.floor(vh * 0.78), maxH);
      root.style.setProperty('--chat-sheet-height', `${preferred}px`);
    }

    function lockScroll(lock) {
      if (!isMobileSheet()) return;
      if (lock) {
        scrollY = window.scrollY || 0;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      } else {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
    }

    function updateSendState() {
      if (!sendBtn) return;
      sendBtn.disabled = !String(input.value || '').trim() || busy;
    }

    function scrollToBottom() {
      messages.scrollTop = messages.scrollHeight;
    }

    function addBubble(html, role) {
      const el = document.createElement('div');
      el.className = `fouru-chat-bubble fouru-chat-bubble--${role}`;
      el.innerHTML = html;
      messages.appendChild(el);
      scrollToBottom();
      return el;
    }

    function setSuggestions(list) {
      suggestionsEl.innerHTML = '';
      (list || []).forEach((label) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'fouru-chat-chip';
        chip.textContent = label;
        chip.addEventListener('click', () => ask(label));
        suggestionsEl.appendChild(chip);
      });
    }

    function showTyping() {
      const el = document.createElement('div');
      el.className = 'fouru-chat-bubble fouru-chat-bubble--bot fouru-chat-bubble--typing';
      el.setAttribute('aria-label', 'Virtual Barber is typing');
      el.innerHTML = '<span class="fouru-chat-dot"></span><span class="fouru-chat-dot"></span><span class="fouru-chat-dot"></span>';
      messages.appendChild(el);
      scrollToBottom();
      return el;
    }

    function getFocusable() {
      return [...panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
        .filter((el) => !el.hasAttribute('disabled') && el.getClientRects().length > 0);
    }

    function setOpen(next) {
      if (next === open) return;
      open = next;
      root.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggleBtn.setAttribute(
        'aria-label',
        open ? 'Close 4U AI chat' : 'Chat to 4U AI to find your perfect products'
      );

      if (open) {
        panel.hidden = false;
        lastFocus = document.activeElement;
        try { localStorage.setItem('fouru_chat_seen', '1'); } catch (e) { /* */ }
        hideTeaser(true);
        root.classList.remove('fouru-chat--nudge');
        lockScroll(true);
        syncSheetHeight();
        syncStickyOffset();

        if (!greeted) {
          greeted = true;
          addBubble(`<p>${escapeHtml(cfg.greeting)}</p>`, 'bot');
          setSuggestions(defaultSuggestions());
        }
        window.setTimeout(() => {
          if (!isMobileSheet()) input.focus({ preventScroll: true });
          updateSendState();
          scrollToBottom();
        }, 60);
      } else {
        lockScroll(false);
        root.style.removeProperty('--chat-sheet-height');
        syncStickyOffset();
        window.setTimeout(() => {
          if (!open) panel.hidden = true;
        }, 320);
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }
    }

    function ask(raw) {
      const text = String(raw || '').trim();
      if (!text || busy) return;
      busy = true;
      updateSendState();
      input.value = '';
      addBubble(`<p>${escapeHtml(text)}</p>`, 'user');
      setSuggestions([]);
      const typing = showTyping();

      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 80
        : 280 + Math.min(400, text.length * 5);

      window.setTimeout(async () => {
        try {
          const result = await composeAnswerAsync(text);
          typing.remove();
          addBubble(result.html, 'bot');
          setSuggestions(result.suggestions);
          pushChatHistory('user', text);
          pushChatHistory('assistant', result.html);
        } catch (e) {
          typing.remove();
          const fallback = composeAnswer(text);
          addBubble(fallback.html, 'bot');
          setSuggestions(fallback.suggestions);
          pushChatHistory('user', text);
          pushChatHistory('assistant', fallback.html);
        }
        busy = false;
        updateSendState();
        if (!isMobileSheet()) input.focus({ preventScroll: true });
        scrollToBottom();
      }, delay);
    }

    toggleTargets.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn === toggleBtn) setOpen(!open);
        else setOpen(true);
      });
    });
    if (teaserDismissBtn) {
      teaserDismissBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hideTeaser(true);
      });
    }
    closeBtn.addEventListener('click', () => setOpen(false));
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      ask(input.value);
      if (isMobileSheet()) input.blur();
    });
    input.addEventListener('input', updateSendState);
    input.addEventListener('focus', () => {
      syncSheetHeight();
      window.setTimeout(scrollToBottom, 120);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncSheetHeight);
      window.visualViewport.addEventListener('scroll', syncSheetHeight);
    }
    window.addEventListener('resize', () => {
      syncSheetHeight();
      syncStickyOffset();
    });

    document.addEventListener('keydown', (e) => {
      if (!open) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        setOpen(false);
        return;
      }
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('pointerdown', (e) => {
      if (!open) return;
      if (panel.contains(e.target) || toggleTargets.some((btn) => btn.contains(e.target))) return;
      if (isMobileSheet() && e.target === root) {
        setOpen(false);
        return;
      }
      if (!root.contains(e.target)) setOpen(false);
    });

    updateSendState();
    resetSessionSoft();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
